"use strict";
// tslint:disable
/**
 * MAPI v2 INTERNAL API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var globalImportUrl = __importStar(require("url"));
var axios_1 = __importDefault(require("axios"));
// Some imports not used depending on template conditions
// @ts-ignore
var base_1 = require("./base");
/**
    * @export
    * @enum {string}
    */
var MessageAttachmentAttachmentTypeEnum;
(function (MessageAttachmentAttachmentTypeEnum) {
    MessageAttachmentAttachmentTypeEnum["Core"] = "Core";
    MessageAttachmentAttachmentTypeEnum["Embedded"] = "Embedded";
    MessageAttachmentAttachmentTypeEnum["Attached"] = "Attached";
    MessageAttachmentAttachmentTypeEnum["External"] = "External";
    MessageAttachmentAttachmentTypeEnum["Original"] = "Original";
    MessageAttachmentAttachmentTypeEnum["Unknown"] = "Unknown";
})(MessageAttachmentAttachmentTypeEnum = exports.MessageAttachmentAttachmentTypeEnum || (exports.MessageAttachmentAttachmentTypeEnum = {}));
/**
    * @export
    * @enum {string}
    */
var MessageAttachmentOutputAttachmentTypeEnum;
(function (MessageAttachmentOutputAttachmentTypeEnum) {
    MessageAttachmentOutputAttachmentTypeEnum["Core"] = "Core";
    MessageAttachmentOutputAttachmentTypeEnum["Embedded"] = "Embedded";
    MessageAttachmentOutputAttachmentTypeEnum["Attached"] = "Attached";
    MessageAttachmentOutputAttachmentTypeEnum["External"] = "External";
    MessageAttachmentOutputAttachmentTypeEnum["Original"] = "Original";
    MessageAttachmentOutputAttachmentTypeEnum["Unknown"] = "Unknown";
})(MessageAttachmentOutputAttachmentTypeEnum = exports.MessageAttachmentOutputAttachmentTypeEnum || (exports.MessageAttachmentOutputAttachmentTypeEnum = {}));
/**
    * @export
    * @enum {string}
    */
var MessageLogSeverityEnumEnum;
(function (MessageLogSeverityEnumEnum) {
    MessageLogSeverityEnumEnum["Debug"] = "Debug";
    MessageLogSeverityEnumEnum["Info"] = "Info";
    MessageLogSeverityEnumEnum["Warning"] = "Warning";
    MessageLogSeverityEnumEnum["Error"] = "Error";
    MessageLogSeverityEnumEnum["Fatal"] = "Fatal";
})(MessageLogSeverityEnumEnum = exports.MessageLogSeverityEnumEnum || (exports.MessageLogSeverityEnumEnum = {}));
/**
    * @export
    * @enum {string}
    */
var MessageServicesStatusStatusEnum;
(function (MessageServicesStatusStatusEnum) {
    MessageServicesStatusStatusEnum["Created"] = "Created";
    MessageServicesStatusStatusEnum["Failed"] = "Failed";
    MessageServicesStatusStatusEnum["Hold"] = "Hold";
    MessageServicesStatusStatusEnum["New"] = "New";
    MessageServicesStatusStatusEnum["Processed"] = "Processed";
    MessageServicesStatusStatusEnum["Queued"] = "Queued";
    MessageServicesStatusStatusEnum["Retried"] = "Retried";
})(MessageServicesStatusStatusEnum = exports.MessageServicesStatusStatusEnum || (exports.MessageServicesStatusStatusEnum = {}));
/**
    * @export
    * @enum {string}
    */
var MessageServicesStatusChangedUiOutputKeyEnum;
(function (MessageServicesStatusChangedUiOutputKeyEnum) {
    MessageServicesStatusChangedUiOutputKeyEnum["Failed"] = "Failed";
    MessageServicesStatusChangedUiOutputKeyEnum["Retrying"] = "Retrying";
    MessageServicesStatusChangedUiOutputKeyEnum["Parked"] = "Parked";
    MessageServicesStatusChangedUiOutputKeyEnum["NotFound"] = "NotFound";
})(MessageServicesStatusChangedUiOutputKeyEnum = exports.MessageServicesStatusChangedUiOutputKeyEnum || (exports.MessageServicesStatusChangedUiOutputKeyEnum = {}));
/**
    * @export
    * @enum {string}
    */
var MessageStatusStatusEnum;
(function (MessageStatusStatusEnum) {
    MessageStatusStatusEnum["NotSet"] = "NotSet";
    MessageStatusStatusEnum["Received"] = "Received";
    MessageStatusStatusEnum["Delivered"] = "Delivered";
    MessageStatusStatusEnum["Processed"] = "Processed";
    MessageStatusStatusEnum["Failed"] = "Failed";
    MessageStatusStatusEnum["PendingDelivery"] = "PendingDelivery";
    MessageStatusStatusEnum["PendingProcessing"] = "PendingProcessing";
    MessageStatusStatusEnum["Parked"] = "Parked";
    MessageStatusStatusEnum["Logged"] = "Logged";
    MessageStatusStatusEnum["LoggedFailed"] = "LoggedFailed";
    MessageStatusStatusEnum["Retrying"] = "Retrying";
    MessageStatusStatusEnum["NotProcessing"] = "NotProcessing";
    MessageStatusStatusEnum["LoggedRelayed"] = "LoggedRelayed";
    MessageStatusStatusEnum["PendingReview"] = "PendingReview";
    MessageStatusStatusEnum["PendingInformation"] = "PendingInformation";
})(MessageStatusStatusEnum = exports.MessageStatusStatusEnum || (exports.MessageStatusStatusEnum = {}));
/**
    * @export
    * @enum {string}
    */
var MessageStatusChangedUIOutputKeyEnum;
(function (MessageStatusChangedUIOutputKeyEnum) {
    MessageStatusChangedUIOutputKeyEnum["Failed"] = "Failed";
    MessageStatusChangedUIOutputKeyEnum["Retrying"] = "Retrying";
    MessageStatusChangedUIOutputKeyEnum["Parked"] = "Parked";
    MessageStatusChangedUIOutputKeyEnum["NotFound"] = "NotFound";
})(MessageStatusChangedUIOutputKeyEnum = exports.MessageStatusChangedUIOutputKeyEnum || (exports.MessageStatusChangedUIOutputKeyEnum = {}));
/**
    * @export
    * @enum {string}
    */
var MessageStatusWithTracesUiOutputMessageStatusEnum;
(function (MessageStatusWithTracesUiOutputMessageStatusEnum) {
    MessageStatusWithTracesUiOutputMessageStatusEnum["Delivered"] = "Delivered";
    MessageStatusWithTracesUiOutputMessageStatusEnum["Failed"] = "Failed";
    MessageStatusWithTracesUiOutputMessageStatusEnum["InProcess"] = "InProcess";
    MessageStatusWithTracesUiOutputMessageStatusEnum["New"] = "New";
    MessageStatusWithTracesUiOutputMessageStatusEnum["Other"] = "Other";
    MessageStatusWithTracesUiOutputMessageStatusEnum["Parked"] = "Parked";
})(MessageStatusWithTracesUiOutputMessageStatusEnum = exports.MessageStatusWithTracesUiOutputMessageStatusEnum || (exports.MessageStatusWithTracesUiOutputMessageStatusEnum = {}));
/**
    * @export
    * @enum {string}
    */
var MessageStatusWithTracesUiOutputInternalMessageStatusEnum;
(function (MessageStatusWithTracesUiOutputInternalMessageStatusEnum) {
    MessageStatusWithTracesUiOutputInternalMessageStatusEnum["NotSet"] = "NotSet";
    MessageStatusWithTracesUiOutputInternalMessageStatusEnum["Received"] = "Received";
    MessageStatusWithTracesUiOutputInternalMessageStatusEnum["Delivered"] = "Delivered";
    MessageStatusWithTracesUiOutputInternalMessageStatusEnum["Processed"] = "Processed";
    MessageStatusWithTracesUiOutputInternalMessageStatusEnum["Failed"] = "Failed";
    MessageStatusWithTracesUiOutputInternalMessageStatusEnum["PendingDelivery"] = "PendingDelivery";
    MessageStatusWithTracesUiOutputInternalMessageStatusEnum["PendingProcessing"] = "PendingProcessing";
    MessageStatusWithTracesUiOutputInternalMessageStatusEnum["Parked"] = "Parked";
    MessageStatusWithTracesUiOutputInternalMessageStatusEnum["Logged"] = "Logged";
    MessageStatusWithTracesUiOutputInternalMessageStatusEnum["LoggedFailed"] = "LoggedFailed";
    MessageStatusWithTracesUiOutputInternalMessageStatusEnum["Retrying"] = "Retrying";
    MessageStatusWithTracesUiOutputInternalMessageStatusEnum["NotProcessing"] = "NotProcessing";
    MessageStatusWithTracesUiOutputInternalMessageStatusEnum["LoggedRelayed"] = "LoggedRelayed";
    MessageStatusWithTracesUiOutputInternalMessageStatusEnum["PendingReview"] = "PendingReview";
    MessageStatusWithTracesUiOutputInternalMessageStatusEnum["PendingInformation"] = "PendingInformation";
})(MessageStatusWithTracesUiOutputInternalMessageStatusEnum = exports.MessageStatusWithTracesUiOutputInternalMessageStatusEnum || (exports.MessageStatusWithTracesUiOutputInternalMessageStatusEnum = {}));
/**
    * @export
    * @enum {string}
    */
var MessageTraceUiOutputTraceTypeKeyNameEnum;
(function (MessageTraceUiOutputTraceTypeKeyNameEnum) {
    MessageTraceUiOutputTraceTypeKeyNameEnum["AddAttachmentOpen"] = "AddAttachmentOpen";
    MessageTraceUiOutputTraceTypeKeyNameEnum["AddAttachmentClosed"] = "AddAttachmentClosed";
    MessageTraceUiOutputTraceTypeKeyNameEnum["CreateOpen"] = "CreateOpen";
    MessageTraceUiOutputTraceTypeKeyNameEnum["CreateClosed"] = "CreateClosed";
    MessageTraceUiOutputTraceTypeKeyNameEnum["DeliveredToExternal"] = "DeliveredToExternal";
    MessageTraceUiOutputTraceTypeKeyNameEnum["MarkFailed"] = "MarkFailed";
    MessageTraceUiOutputTraceTypeKeyNameEnum["ReceivedFromExternal"] = "ReceivedFromExternal";
    MessageTraceUiOutputTraceTypeKeyNameEnum["MovedToReceiverInbox"] = "MovedToReceiverInbox";
    MessageTraceUiOutputTraceTypeKeyNameEnum["SentByMail"] = "SentByMail";
    MessageTraceUiOutputTraceTypeKeyNameEnum["DeliveredToExternalNoAck"] = "DeliveredToExternalNoAck";
    MessageTraceUiOutputTraceTypeKeyNameEnum["Park"] = "Park";
    MessageTraceUiOutputTraceTypeKeyNameEnum["SentToPrintingService"] = "SentToPrintingService";
    MessageTraceUiOutputTraceTypeKeyNameEnum["MarkReceived"] = "MarkReceived";
    MessageTraceUiOutputTraceTypeKeyNameEnum["ProcessedByService"] = "ProcessedByService";
    MessageTraceUiOutputTraceTypeKeyNameEnum["DeliveredToExternalPending"] = "DeliveredToExternalPending";
    MessageTraceUiOutputTraceTypeKeyNameEnum["ViewAttachment"] = "ViewAttachment";
    MessageTraceUiOutputTraceTypeKeyNameEnum["MarkProcessed"] = "MarkProcessed";
    MessageTraceUiOutputTraceTypeKeyNameEnum["Retry"] = "Retry";
    MessageTraceUiOutputTraceTypeKeyNameEnum["Unknown"] = "Unknown";
})(MessageTraceUiOutputTraceTypeKeyNameEnum = exports.MessageTraceUiOutputTraceTypeKeyNameEnum || (exports.MessageTraceUiOutputTraceTypeKeyNameEnum = {}));
/**
    * @export
    * @enum {string}
    */
var MessageTransferTransferEnum;
(function (MessageTransferTransferEnum) {
    MessageTransferTransferEnum["Unknown"] = "Unknown";
    MessageTransferTransferEnum["Internal"] = "Internal";
    MessageTransferTransferEnum["Outbound"] = "Outbound";
    MessageTransferTransferEnum["Inbound"] = "Inbound";
    MessageTransferTransferEnum["Routed"] = "Routed";
})(MessageTransferTransferEnum = exports.MessageTransferTransferEnum || (exports.MessageTransferTransferEnum = {}));
/**
    * @export
    * @enum {string}
    */
var MessageValidationStatusUIOutputKeyEnum;
(function (MessageValidationStatusUIOutputKeyEnum) {
    MessageValidationStatusUIOutputKeyEnum["MissingData"] = "MissingData";
    MessageValidationStatusUIOutputKeyEnum["Ignored"] = "Ignored";
    MessageValidationStatusUIOutputKeyEnum["Invalid"] = "Invalid";
    MessageValidationStatusUIOutputKeyEnum["Unknown"] = "Unknown";
    MessageValidationStatusUIOutputKeyEnum["Valid"] = "Valid";
})(MessageValidationStatusUIOutputKeyEnum = exports.MessageValidationStatusUIOutputKeyEnum || (exports.MessageValidationStatusUIOutputKeyEnum = {}));
/**
    * @export
    * @enum {string}
    */
var MessageValidationUIOutputValidationEntryStatusEnum;
(function (MessageValidationUIOutputValidationEntryStatusEnum) {
    MessageValidationUIOutputValidationEntryStatusEnum["MissingData"] = "MissingData";
    MessageValidationUIOutputValidationEntryStatusEnum["SchemaError"] = "SchemaError";
    MessageValidationUIOutputValidationEntryStatusEnum["SchemaWarning"] = "SchemaWarning";
    MessageValidationUIOutputValidationEntryStatusEnum["SchemaErrorOverridden"] = "SchemaErrorOverridden";
    MessageValidationUIOutputValidationEntryStatusEnum["SchematronError"] = "SchematronError";
    MessageValidationUIOutputValidationEntryStatusEnum["GeneralError"] = "GeneralError";
    MessageValidationUIOutputValidationEntryStatusEnum["Ok"] = "Ok";
    MessageValidationUIOutputValidationEntryStatusEnum["SchematronWarning"] = "SchematronWarning";
    MessageValidationUIOutputValidationEntryStatusEnum["SchematronErrorOverridden"] = "SchematronErrorOverridden";
})(MessageValidationUIOutputValidationEntryStatusEnum = exports.MessageValidationUIOutputValidationEntryStatusEnum || (exports.MessageValidationUIOutputValidationEntryStatusEnum = {}));
/**
 * UIAuditLogApi - axios parameter creator
 * @export
 */
exports.UIAuditLogApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {string} [source]
         * @param {string} [key]
         * @param {string} [context]
         * @param {number} [offset]
         * @param {number} [limit]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2LogsAuditGet: function (source, key, context, offset, limit, options) {
            if (options === void 0) { options = {}; }
            var localVarPath = "/api/v2/logs/audit";
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign({ method: 'GET' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            // authentication oauth2 required
            // oauth required
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["partner-api-v2"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            if (source !== undefined) {
                localVarQueryParameter['source'] = source;
            }
            if (key !== undefined) {
                localVarQueryParameter['key'] = key;
            }
            if (context !== undefined) {
                localVarQueryParameter['context'] = context;
            }
            if (offset !== undefined) {
                localVarQueryParameter['Offset'] = offset;
            }
            if (limit !== undefined) {
                localVarQueryParameter['Limit'] = limit;
            }
            localVarUrlObj.query = __assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign({}, localVarHeaderParameter, options.headers);
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * UIAuditLogApi - functional programming interface
 * @export
 */
exports.UIAuditLogApiFp = function (configuration) {
    return {
        /**
         *
         * @param {string} [source]
         * @param {string} [key]
         * @param {string} [context]
         * @param {number} [offset]
         * @param {number} [limit]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2LogsAuditGet: function (source, key, context, offset, limit, options) {
            var localVarAxiosArgs = exports.UIAuditLogApiAxiosParamCreator(configuration).apiV2LogsAuditGet(source, key, context, offset, limit, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = axios_1.default; }
                if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                var axiosRequestArgs = __assign({}, localVarAxiosArgs.options, { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
    };
};
/**
 * UIAuditLogApi - factory interface
 * @export
 */
exports.UIAuditLogApiFactory = function (configuration, basePath, axios) {
    return {
        /**
         *
         * @param {string} [source]
         * @param {string} [key]
         * @param {string} [context]
         * @param {number} [offset]
         * @param {number} [limit]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2LogsAuditGet: function (source, key, context, offset, limit, options) {
            return exports.UIAuditLogApiFp(configuration).apiV2LogsAuditGet(source, key, context, offset, limit, options)(axios, basePath);
        },
    };
};
/**
 * UIAuditLogApi - object-oriented interface
 * @export
 * @class UIAuditLogApi
 * @extends {BaseAPI}
 */
var UIAuditLogApi = /** @class */ (function (_super) {
    __extends(UIAuditLogApi, _super);
    function UIAuditLogApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @param {string} [source]
     * @param {string} [key]
     * @param {string} [context]
     * @param {number} [offset]
     * @param {number} [limit]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UIAuditLogApi
     */
    UIAuditLogApi.prototype.apiV2LogsAuditGet = function (source, key, context, offset, limit, options) {
        return exports.UIAuditLogApiFp(this.configuration).apiV2LogsAuditGet(source, key, context, offset, limit, options)(this.axios, this.basePath);
    };
    return UIAuditLogApi;
}(base_1.BaseAPI));
exports.UIAuditLogApi = UIAuditLogApi;
/**
 * UIBillingApi - axios parameter creator
 * @export
 */
exports.UIBillingApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Retrieves parties by their name or a substring of their name.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uiApiV2BillingCustomersGet: function (options) {
            if (options === void 0) { options = {}; }
            var localVarPath = "/ui/api/v2/billing/customers";
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign({ method: 'GET' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            // authentication oauth2 required
            // oauth required
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["partner-api-v2"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarUrlObj.query = __assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign({}, localVarHeaderParameter, options.headers);
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * UIBillingApi - functional programming interface
 * @export
 */
exports.UIBillingApiFp = function (configuration) {
    return {
        /**
         *
         * @summary Retrieves parties by their name or a substring of their name.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uiApiV2BillingCustomersGet: function (options) {
            var localVarAxiosArgs = exports.UIBillingApiAxiosParamCreator(configuration).uiApiV2BillingCustomersGet(options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = axios_1.default; }
                if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                var axiosRequestArgs = __assign({}, localVarAxiosArgs.options, { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
    };
};
/**
 * UIBillingApi - factory interface
 * @export
 */
exports.UIBillingApiFactory = function (configuration, basePath, axios) {
    return {
        /**
         *
         * @summary Retrieves parties by their name or a substring of their name.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uiApiV2BillingCustomersGet: function (options) {
            return exports.UIBillingApiFp(configuration).uiApiV2BillingCustomersGet(options)(axios, basePath);
        },
    };
};
/**
 * UIBillingApi - object-oriented interface
 * @export
 * @class UIBillingApi
 * @extends {BaseAPI}
 */
var UIBillingApi = /** @class */ (function (_super) {
    __extends(UIBillingApi, _super);
    function UIBillingApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary Retrieves parties by their name or a substring of their name.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UIBillingApi
     */
    UIBillingApi.prototype.uiApiV2BillingCustomersGet = function (options) {
        return exports.UIBillingApiFp(this.configuration).uiApiV2BillingCustomersGet(options)(this.axios, this.basePath);
    };
    return UIBillingApi;
}(base_1.BaseAPI));
exports.UIBillingApi = UIBillingApi;
/**
 * UIDashboardApi - axios parameter creator
 * @export
 */
exports.UIDashboardApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Gets the service summary.
         * @param {string} [partyIdentifier]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uiApiV2DashboardServiceSummariesGet: function (partyIdentifier, options) {
            if (options === void 0) { options = {}; }
            var localVarPath = "/ui/api/v2/dashboard/service-summaries";
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign({ method: 'GET' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            // authentication oauth2 required
            // oauth required
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["partner-api-v2"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            if (partyIdentifier !== undefined) {
                localVarQueryParameter['partyIdentifier'] = partyIdentifier;
            }
            localVarUrlObj.query = __assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign({}, localVarHeaderParameter, options.headers);
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Gets the usage summaries for a period of time.
         * @param {'Month' | 'Quarter' | 'Year'} period
         * @param {string} [partyIdentifier]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uiApiV2DashboardUsageSummariesGet: function (period, partyIdentifier, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'period' is not null or undefined
            if (period === null || period === undefined) {
                throw new base_1.RequiredError('period', 'Required parameter period was null or undefined when calling uiApiV2DashboardUsageSummariesGet.');
            }
            var localVarPath = "/ui/api/v2/dashboard/usage-summaries";
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign({ method: 'GET' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            // authentication oauth2 required
            // oauth required
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["partner-api-v2"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            if (partyIdentifier !== undefined) {
                localVarQueryParameter['PartyIdentifier'] = partyIdentifier;
            }
            if (period !== undefined) {
                localVarQueryParameter['Period'] = period;
            }
            localVarUrlObj.query = __assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign({}, localVarHeaderParameter, options.headers);
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * UIDashboardApi - functional programming interface
 * @export
 */
exports.UIDashboardApiFp = function (configuration) {
    return {
        /**
         *
         * @summary Gets the service summary.
         * @param {string} [partyIdentifier]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uiApiV2DashboardServiceSummariesGet: function (partyIdentifier, options) {
            var localVarAxiosArgs = exports.UIDashboardApiAxiosParamCreator(configuration).uiApiV2DashboardServiceSummariesGet(partyIdentifier, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = axios_1.default; }
                if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                var axiosRequestArgs = __assign({}, localVarAxiosArgs.options, { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @summary Gets the usage summaries for a period of time.
         * @param {'Month' | 'Quarter' | 'Year'} period
         * @param {string} [partyIdentifier]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uiApiV2DashboardUsageSummariesGet: function (period, partyIdentifier, options) {
            var localVarAxiosArgs = exports.UIDashboardApiAxiosParamCreator(configuration).uiApiV2DashboardUsageSummariesGet(period, partyIdentifier, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = axios_1.default; }
                if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                var axiosRequestArgs = __assign({}, localVarAxiosArgs.options, { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
    };
};
/**
 * UIDashboardApi - factory interface
 * @export
 */
exports.UIDashboardApiFactory = function (configuration, basePath, axios) {
    return {
        /**
         *
         * @summary Gets the service summary.
         * @param {string} [partyIdentifier]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uiApiV2DashboardServiceSummariesGet: function (partyIdentifier, options) {
            return exports.UIDashboardApiFp(configuration).uiApiV2DashboardServiceSummariesGet(partyIdentifier, options)(axios, basePath);
        },
        /**
         *
         * @summary Gets the usage summaries for a period of time.
         * @param {'Month' | 'Quarter' | 'Year'} period
         * @param {string} [partyIdentifier]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uiApiV2DashboardUsageSummariesGet: function (period, partyIdentifier, options) {
            return exports.UIDashboardApiFp(configuration).uiApiV2DashboardUsageSummariesGet(period, partyIdentifier, options)(axios, basePath);
        },
    };
};
/**
 * UIDashboardApi - object-oriented interface
 * @export
 * @class UIDashboardApi
 * @extends {BaseAPI}
 */
var UIDashboardApi = /** @class */ (function (_super) {
    __extends(UIDashboardApi, _super);
    function UIDashboardApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary Gets the service summary.
     * @param {string} [partyIdentifier]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UIDashboardApi
     */
    UIDashboardApi.prototype.uiApiV2DashboardServiceSummariesGet = function (partyIdentifier, options) {
        return exports.UIDashboardApiFp(this.configuration).uiApiV2DashboardServiceSummariesGet(partyIdentifier, options)(this.axios, this.basePath);
    };
    /**
     *
     * @summary Gets the usage summaries for a period of time.
     * @param {'Month' | 'Quarter' | 'Year'} period
     * @param {string} [partyIdentifier]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UIDashboardApi
     */
    UIDashboardApi.prototype.uiApiV2DashboardUsageSummariesGet = function (period, partyIdentifier, options) {
        return exports.UIDashboardApiFp(this.configuration).uiApiV2DashboardUsageSummariesGet(period, partyIdentifier, options)(this.axios, this.basePath);
    };
    return UIDashboardApi;
}(base_1.BaseAPI));
exports.UIDashboardApi = UIDashboardApi;
/**
 * UIEnumerationApi - axios parameter creator
 * @export
 */
exports.UIEnumerationApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Get all types of Message Service Statuses
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uiApiV2EnumerationMessageServiceStatusesGet: function (options) {
            if (options === void 0) { options = {}; }
            var localVarPath = "/ui/api/v2/enumeration/MessageServiceStatuses";
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign({ method: 'GET' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            // authentication oauth2 required
            // oauth required
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["partner-api-v2"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarUrlObj.query = __assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign({}, localVarHeaderParameter, options.headers);
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get all types of Message Validation Statuses
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uiApiV2EnumerationMessageValidationStatusesGet: function (options) {
            if (options === void 0) { options = {}; }
            var localVarPath = "/ui/api/v2/enumeration/MessageValidationStatuses";
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign({ method: 'GET' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            // authentication oauth2 required
            // oauth required
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["partner-api-v2"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarUrlObj.query = __assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign({}, localVarHeaderParameter, options.headers);
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get all types of Message Statuses
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uiApiV2EnumerationsMessageStatusesGet: function (options) {
            if (options === void 0) { options = {}; }
            var localVarPath = "/ui/api/v2/enumerations/MessageStatuses";
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign({ method: 'GET' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            // authentication oauth2 required
            // oauth required
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["partner-api-v2"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarUrlObj.query = __assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign({}, localVarHeaderParameter, options.headers);
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get all types of Message Transfers
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uiApiV2EnumerationsMessageTransfersGet: function (options) {
            if (options === void 0) { options = {}; }
            var localVarPath = "/ui/api/v2/enumerations/MessageTransfers";
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign({ method: 'GET' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            // authentication oauth2 required
            // oauth required
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["partner-api-v2"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarUrlObj.query = __assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign({}, localVarHeaderParameter, options.headers);
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get all business transaction groups
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uiApiV2EnumerationsTransactionGroupsGet: function (options) {
            if (options === void 0) { options = {}; }
            var localVarPath = "/ui/api/v2/enumerations/TransactionGroups";
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign({ method: 'GET' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            // authentication oauth2 required
            // oauth required
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["partner-api-v2"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarUrlObj.query = __assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign({}, localVarHeaderParameter, options.headers);
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * UIEnumerationApi - functional programming interface
 * @export
 */
exports.UIEnumerationApiFp = function (configuration) {
    return {
        /**
         *
         * @summary Get all types of Message Service Statuses
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uiApiV2EnumerationMessageServiceStatusesGet: function (options) {
            var localVarAxiosArgs = exports.UIEnumerationApiAxiosParamCreator(configuration).uiApiV2EnumerationMessageServiceStatusesGet(options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = axios_1.default; }
                if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                var axiosRequestArgs = __assign({}, localVarAxiosArgs.options, { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @summary Get all types of Message Validation Statuses
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uiApiV2EnumerationMessageValidationStatusesGet: function (options) {
            var localVarAxiosArgs = exports.UIEnumerationApiAxiosParamCreator(configuration).uiApiV2EnumerationMessageValidationStatusesGet(options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = axios_1.default; }
                if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                var axiosRequestArgs = __assign({}, localVarAxiosArgs.options, { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @summary Get all types of Message Statuses
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uiApiV2EnumerationsMessageStatusesGet: function (options) {
            var localVarAxiosArgs = exports.UIEnumerationApiAxiosParamCreator(configuration).uiApiV2EnumerationsMessageStatusesGet(options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = axios_1.default; }
                if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                var axiosRequestArgs = __assign({}, localVarAxiosArgs.options, { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @summary Get all types of Message Transfers
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uiApiV2EnumerationsMessageTransfersGet: function (options) {
            var localVarAxiosArgs = exports.UIEnumerationApiAxiosParamCreator(configuration).uiApiV2EnumerationsMessageTransfersGet(options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = axios_1.default; }
                if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                var axiosRequestArgs = __assign({}, localVarAxiosArgs.options, { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @summary Get all business transaction groups
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uiApiV2EnumerationsTransactionGroupsGet: function (options) {
            var localVarAxiosArgs = exports.UIEnumerationApiAxiosParamCreator(configuration).uiApiV2EnumerationsTransactionGroupsGet(options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = axios_1.default; }
                if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                var axiosRequestArgs = __assign({}, localVarAxiosArgs.options, { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
    };
};
/**
 * UIEnumerationApi - factory interface
 * @export
 */
exports.UIEnumerationApiFactory = function (configuration, basePath, axios) {
    return {
        /**
         *
         * @summary Get all types of Message Service Statuses
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uiApiV2EnumerationMessageServiceStatusesGet: function (options) {
            return exports.UIEnumerationApiFp(configuration).uiApiV2EnumerationMessageServiceStatusesGet(options)(axios, basePath);
        },
        /**
         *
         * @summary Get all types of Message Validation Statuses
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uiApiV2EnumerationMessageValidationStatusesGet: function (options) {
            return exports.UIEnumerationApiFp(configuration).uiApiV2EnumerationMessageValidationStatusesGet(options)(axios, basePath);
        },
        /**
         *
         * @summary Get all types of Message Statuses
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uiApiV2EnumerationsMessageStatusesGet: function (options) {
            return exports.UIEnumerationApiFp(configuration).uiApiV2EnumerationsMessageStatusesGet(options)(axios, basePath);
        },
        /**
         *
         * @summary Get all types of Message Transfers
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uiApiV2EnumerationsMessageTransfersGet: function (options) {
            return exports.UIEnumerationApiFp(configuration).uiApiV2EnumerationsMessageTransfersGet(options)(axios, basePath);
        },
        /**
         *
         * @summary Get all business transaction groups
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uiApiV2EnumerationsTransactionGroupsGet: function (options) {
            return exports.UIEnumerationApiFp(configuration).uiApiV2EnumerationsTransactionGroupsGet(options)(axios, basePath);
        },
    };
};
/**
 * UIEnumerationApi - object-oriented interface
 * @export
 * @class UIEnumerationApi
 * @extends {BaseAPI}
 */
var UIEnumerationApi = /** @class */ (function (_super) {
    __extends(UIEnumerationApi, _super);
    function UIEnumerationApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary Get all types of Message Service Statuses
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UIEnumerationApi
     */
    UIEnumerationApi.prototype.uiApiV2EnumerationMessageServiceStatusesGet = function (options) {
        return exports.UIEnumerationApiFp(this.configuration).uiApiV2EnumerationMessageServiceStatusesGet(options)(this.axios, this.basePath);
    };
    /**
     *
     * @summary Get all types of Message Validation Statuses
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UIEnumerationApi
     */
    UIEnumerationApi.prototype.uiApiV2EnumerationMessageValidationStatusesGet = function (options) {
        return exports.UIEnumerationApiFp(this.configuration).uiApiV2EnumerationMessageValidationStatusesGet(options)(this.axios, this.basePath);
    };
    /**
     *
     * @summary Get all types of Message Statuses
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UIEnumerationApi
     */
    UIEnumerationApi.prototype.uiApiV2EnumerationsMessageStatusesGet = function (options) {
        return exports.UIEnumerationApiFp(this.configuration).uiApiV2EnumerationsMessageStatusesGet(options)(this.axios, this.basePath);
    };
    /**
     *
     * @summary Get all types of Message Transfers
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UIEnumerationApi
     */
    UIEnumerationApi.prototype.uiApiV2EnumerationsMessageTransfersGet = function (options) {
        return exports.UIEnumerationApiFp(this.configuration).uiApiV2EnumerationsMessageTransfersGet(options)(this.axios, this.basePath);
    };
    /**
     *
     * @summary Get all business transaction groups
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UIEnumerationApi
     */
    UIEnumerationApi.prototype.uiApiV2EnumerationsTransactionGroupsGet = function (options) {
        return exports.UIEnumerationApiFp(this.configuration).uiApiV2EnumerationsTransactionGroupsGet(options)(this.axios, this.basePath);
    };
    return UIEnumerationApi;
}(base_1.BaseAPI));
exports.UIEnumerationApi = UIEnumerationApi;
/**
 * UIMessageApi - axios parameter creator
 * @export
 */
exports.UIMessageApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Get the attributes connected to the GUID of a message.
         * @param {string} messageGuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uiApiV2MessagesByMessageGuidAttributesGet: function (messageGuid, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'messageGuid' is not null or undefined
            if (messageGuid === null || messageGuid === undefined) {
                throw new base_1.RequiredError('messageGuid', 'Required parameter messageGuid was null or undefined when calling uiApiV2MessagesByMessageGuidAttributesGet.');
            }
            var localVarPath = "/ui/api/v2/messages/{messageGuid}/attributes"
                .replace("{" + "messageGuid" + "}", encodeURIComponent(String(messageGuid)));
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign({ method: 'GET' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            // authentication oauth2 required
            // oauth required
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["partner-api-v2"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarUrlObj.query = __assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign({}, localVarHeaderParameter, options.headers);
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Deletes a message based on the GUID
         * @param {string} messageGuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uiApiV2MessagesByMessageGuidDelete: function (messageGuid, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'messageGuid' is not null or undefined
            if (messageGuid === null || messageGuid === undefined) {
                throw new base_1.RequiredError('messageGuid', 'Required parameter messageGuid was null or undefined when calling uiApiV2MessagesByMessageGuidDelete.');
            }
            var localVarPath = "/ui/api/v2/messages/{messageGuid}"
                .replace("{" + "messageGuid" + "}", encodeURIComponent(String(messageGuid)));
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign({ method: 'DELETE' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            // authentication oauth2 required
            // oauth required
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["partner-api-v2"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarUrlObj.query = __assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign({}, localVarHeaderParameter, options.headers);
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get the logs connected to the GUID of a message paged
         * @param {string} messageGuid Guid of the message
         * @param {number} [offset]
         * @param {number} [limit]
         * @param {string} [ownerIdentifier] Owner Identifier of the message. Only use if Manager or Admin.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uiApiV2MessagesByMessageGuidLogsGet: function (messageGuid, offset, limit, ownerIdentifier, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'messageGuid' is not null or undefined
            if (messageGuid === null || messageGuid === undefined) {
                throw new base_1.RequiredError('messageGuid', 'Required parameter messageGuid was null or undefined when calling uiApiV2MessagesByMessageGuidLogsGet.');
            }
            var localVarPath = "/ui/api/v2/messages/{messageGuid}/logs"
                .replace("{" + "messageGuid" + "}", encodeURIComponent(String(messageGuid)));
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign({ method: 'GET' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            // authentication oauth2 required
            // oauth required
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["partner-api-v2"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            if (offset !== undefined) {
                localVarQueryParameter['Offset'] = offset;
            }
            if (limit !== undefined) {
                localVarQueryParameter['Limit'] = limit;
            }
            if (ownerIdentifier !== undefined) {
                localVarQueryParameter['ownerIdentifier'] = ownerIdentifier;
            }
            localVarUrlObj.query = __assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign({}, localVarHeaderParameter, options.headers);
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get the status connected to the GUID of a message, along with extended traces
         * @param {string} messageGuid Guid of the message
         * @param {string} [ownerIdentifier] Owner Identifier of the message. Only use if Manager or Admin or if the party can not be determined from the context.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uiApiV2MessagesByMessageGuidStatusGet: function (messageGuid, ownerIdentifier, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'messageGuid' is not null or undefined
            if (messageGuid === null || messageGuid === undefined) {
                throw new base_1.RequiredError('messageGuid', 'Required parameter messageGuid was null or undefined when calling uiApiV2MessagesByMessageGuidStatusGet.');
            }
            var localVarPath = "/ui/api/v2/messages/{messageGuid}/status"
                .replace("{" + "messageGuid" + "}", encodeURIComponent(String(messageGuid)));
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign({ method: 'GET' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            // authentication oauth2 required
            // oauth required
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["partner-api-v2"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            if (ownerIdentifier !== undefined) {
                localVarQueryParameter['ownerIdentifier'] = ownerIdentifier;
            }
            localVarUrlObj.query = __assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign({}, localVarHeaderParameter, options.headers);
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get the traces connected to the GUID of a message
         * @param {string} messageGuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uiApiV2MessagesByMessageGuidTracesGet: function (messageGuid, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'messageGuid' is not null or undefined
            if (messageGuid === null || messageGuid === undefined) {
                throw new base_1.RequiredError('messageGuid', 'Required parameter messageGuid was null or undefined when calling uiApiV2MessagesByMessageGuidTracesGet.');
            }
            var localVarPath = "/ui/api/v2/messages/{messageGuid}/traces"
                .replace("{" + "messageGuid" + "}", encodeURIComponent(String(messageGuid)));
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign({ method: 'GET' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            // authentication oauth2 required
            // oauth required
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["partner-api-v2"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarUrlObj.query = __assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign({}, localVarHeaderParameter, options.headers);
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get a message formatted with a stylesheet.
         * @param {number} messageId Message Id of the message
         * @param {number} index Index of the attachment
         * @param {boolean} raw
         * @param {string} [lang] Requested languages, with fallback options e.g. \&#39;is,en\&#39;. Default is empty.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uiApiV2MessagesByMessageIdDocumentsByIndexViewGet: function (messageId, index, raw, lang, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'messageId' is not null or undefined
            if (messageId === null || messageId === undefined) {
                throw new base_1.RequiredError('messageId', 'Required parameter messageId was null or undefined when calling uiApiV2MessagesByMessageIdDocumentsByIndexViewGet.');
            }
            // verify required parameter 'index' is not null or undefined
            if (index === null || index === undefined) {
                throw new base_1.RequiredError('index', 'Required parameter index was null or undefined when calling uiApiV2MessagesByMessageIdDocumentsByIndexViewGet.');
            }
            // verify required parameter 'raw' is not null or undefined
            if (raw === null || raw === undefined) {
                throw new base_1.RequiredError('raw', 'Required parameter raw was null or undefined when calling uiApiV2MessagesByMessageIdDocumentsByIndexViewGet.');
            }
            var localVarPath = "/ui/api/v2/messages/{messageId}/documents/{index}/view"
                .replace("{" + "messageId" + "}", encodeURIComponent(String(messageId)))
                .replace("{" + "index" + "}", encodeURIComponent(String(index)));
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign({ method: 'GET' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            // authentication oauth2 required
            // oauth required
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["partner-api-v2"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            if (lang !== undefined) {
                localVarQueryParameter['lang'] = lang;
            }
            if (raw !== undefined) {
                localVarQueryParameter['raw'] = raw;
            }
            localVarUrlObj.query = __assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign({}, localVarHeaderParameter, options.headers);
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get the core document connected to the id of a message
         * @param {number} messageId Id of the message
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uiApiV2MessagesByMessageIdDocumentsCoreGet: function (messageId, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'messageId' is not null or undefined
            if (messageId === null || messageId === undefined) {
                throw new base_1.RequiredError('messageId', 'Required parameter messageId was null or undefined when calling uiApiV2MessagesByMessageIdDocumentsCoreGet.');
            }
            var localVarPath = "/ui/api/v2/messages/{messageId}/documents/core"
                .replace("{" + "messageId" + "}", encodeURIComponent(String(messageId)));
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign({ method: 'GET' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            // authentication oauth2 required
            // oauth required
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["partner-api-v2"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarUrlObj.query = __assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign({}, localVarHeaderParameter, options.headers);
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get the documents connected to the id of a message
         * @param {number} messageId Id of the message
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uiApiV2MessagesByMessageIdDocumentsGet: function (messageId, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'messageId' is not null or undefined
            if (messageId === null || messageId === undefined) {
                throw new base_1.RequiredError('messageId', 'Required parameter messageId was null or undefined when calling uiApiV2MessagesByMessageIdDocumentsGet.');
            }
            var localVarPath = "/ui/api/v2/messages/{messageId}/documents"
                .replace("{" + "messageId" + "}", encodeURIComponent(String(messageId)));
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign({ method: 'GET' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            // authentication oauth2 required
            // oauth required
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["partner-api-v2"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarUrlObj.query = __assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign({}, localVarHeaderParameter, options.headers);
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get the original document connected to the id of a message
         * @param {number} messageId Id of the message
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uiApiV2MessagesByMessageIdDocumentsOriginalGet: function (messageId, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'messageId' is not null or undefined
            if (messageId === null || messageId === undefined) {
                throw new base_1.RequiredError('messageId', 'Required parameter messageId was null or undefined when calling uiApiV2MessagesByMessageIdDocumentsOriginalGet.');
            }
            var localVarPath = "/ui/api/v2/messages/{messageId}/documents/original"
                .replace("{" + "messageId" + "}", encodeURIComponent(String(messageId)));
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign({ method: 'GET' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            // authentication oauth2 required
            // oauth required
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["partner-api-v2"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarUrlObj.query = __assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign({}, localVarHeaderParameter, options.headers);
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get the original document connected to the id of a message
         * @param {number} messageId Id of the message
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uiApiV2MessagesByMessageIdDocumentsTransformedGet: function (messageId, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'messageId' is not null or undefined
            if (messageId === null || messageId === undefined) {
                throw new base_1.RequiredError('messageId', 'Required parameter messageId was null or undefined when calling uiApiV2MessagesByMessageIdDocumentsTransformedGet.');
            }
            var localVarPath = "/ui/api/v2/messages/{messageId}/documents/transformed"
                .replace("{" + "messageId" + "}", encodeURIComponent(String(messageId)));
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign({ method: 'GET' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            // authentication oauth2 required
            // oauth required
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["partner-api-v2"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarUrlObj.query = __assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign({}, localVarHeaderParameter, options.headers);
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get a message based on its message Id
         * @param {number} messageId Message Id of the message
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uiApiV2MessagesByMessageIdGet: function (messageId, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'messageId' is not null or undefined
            if (messageId === null || messageId === undefined) {
                throw new base_1.RequiredError('messageId', 'Required parameter messageId was null or undefined when calling uiApiV2MessagesByMessageIdGet.');
            }
            var localVarPath = "/ui/api/v2/messages/{messageId}"
                .replace("{" + "messageId" + "}", encodeURIComponent(String(messageId)));
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign({ method: 'GET' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            // authentication oauth2 required
            // oauth required
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["partner-api-v2"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarUrlObj.query = __assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign({}, localVarHeaderParameter, options.headers);
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get the services connected to the message Id of a message
         * @param {number} messageId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uiApiV2MessagesByMessageIdServicesGet: function (messageId, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'messageId' is not null or undefined
            if (messageId === null || messageId === undefined) {
                throw new base_1.RequiredError('messageId', 'Required parameter messageId was null or undefined when calling uiApiV2MessagesByMessageIdServicesGet.');
            }
            var localVarPath = "/ui/api/v2/messages/{messageId}/services"
                .replace("{" + "messageId" + "}", encodeURIComponent(String(messageId)));
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign({ method: 'GET' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            // authentication oauth2 required
            // oauth required
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["partner-api-v2"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarUrlObj.query = __assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign({}, localVarHeaderParameter, options.headers);
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get the validations connected to the GUID of a message
         * @param {number} messageId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uiApiV2MessagesByMessageIdValidationsGet: function (messageId, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'messageId' is not null or undefined
            if (messageId === null || messageId === undefined) {
                throw new base_1.RequiredError('messageId', 'Required parameter messageId was null or undefined when calling uiApiV2MessagesByMessageIdValidationsGet.');
            }
            var localVarPath = "/ui/api/v2/messages/{messageId}/validations"
                .replace("{" + "messageId" + "}", encodeURIComponent(String(messageId)));
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign({ method: 'GET' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            // authentication oauth2 required
            // oauth required
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["partner-api-v2"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarUrlObj.query = __assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign({}, localVarHeaderParameter, options.headers);
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get all messages based on a filter paged.
         * @param {'NotSet' | 'Received' | 'Delivered' | 'Processed' | 'Failed' | 'PendingDelivery' | 'PendingProcessing' | 'Parked' | 'Logged' | 'LoggedFailed' | 'Retrying' | 'NotProcessing' | 'LoggedRelayed' | 'PendingReview' | 'PendingInformation'} [status]
         * @param {string} [transfer]
         * @param {string} [transactionGroup]
         * @param {Date} [timeReceivedFrom]
         * @param {Date} [timeReceivedTo]
         * @param {string} [sourcePartyIdentifier]
         * @param {string} [sinkPartyIdentifier]
         * @param {string} [ownerPartyIdentifier]
         * @param {string} [fromTextFilter]
         * @param {string} [toTextFilter]
         * @param {string} [messageReference]
         * @param {'MissingData' | 'Ignored' | 'Invalid' | 'Unknown' | 'Valid'} [validationStatus]
         * @param {number} [offset]
         * @param {number} [limit]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uiApiV2MessagesGet: function (status, transfer, transactionGroup, timeReceivedFrom, timeReceivedTo, sourcePartyIdentifier, sinkPartyIdentifier, ownerPartyIdentifier, fromTextFilter, toTextFilter, messageReference, validationStatus, offset, limit, options) {
            if (options === void 0) { options = {}; }
            var localVarPath = "/ui/api/v2/messages";
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign({ method: 'GET' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            // authentication oauth2 required
            // oauth required
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["partner-api-v2"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            if (status !== undefined) {
                localVarQueryParameter['Status'] = status;
            }
            if (transfer !== undefined) {
                localVarQueryParameter['Transfer'] = transfer;
            }
            if (transactionGroup !== undefined) {
                localVarQueryParameter['TransactionGroup'] = transactionGroup;
            }
            if (timeReceivedFrom !== undefined) {
                localVarQueryParameter['TimeReceivedFrom'] = (timeReceivedFrom instanceof Date) ?
                    timeReceivedFrom.toISOString() :
                    timeReceivedFrom;
            }
            if (timeReceivedTo !== undefined) {
                localVarQueryParameter['TimeReceivedTo'] = (timeReceivedTo instanceof Date) ?
                    timeReceivedTo.toISOString() :
                    timeReceivedTo;
            }
            if (sourcePartyIdentifier !== undefined) {
                localVarQueryParameter['SourcePartyIdentifier'] = sourcePartyIdentifier;
            }
            if (sinkPartyIdentifier !== undefined) {
                localVarQueryParameter['SinkPartyIdentifier'] = sinkPartyIdentifier;
            }
            if (ownerPartyIdentifier !== undefined) {
                localVarQueryParameter['OwnerPartyIdentifier'] = ownerPartyIdentifier;
            }
            if (fromTextFilter !== undefined) {
                localVarQueryParameter['FromTextFilter'] = fromTextFilter;
            }
            if (toTextFilter !== undefined) {
                localVarQueryParameter['ToTextFilter'] = toTextFilter;
            }
            if (messageReference !== undefined) {
                localVarQueryParameter['MessageReference'] = messageReference;
            }
            if (validationStatus !== undefined) {
                localVarQueryParameter['ValidationStatus'] = validationStatus;
            }
            if (offset !== undefined) {
                localVarQueryParameter['Offset'] = offset;
            }
            if (limit !== undefined) {
                localVarQueryParameter['Limit'] = limit;
            }
            localVarUrlObj.query = __assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign({}, localVarHeaderParameter, options.headers);
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Parks a message based on its id
         * @param {Array<number>} [messageIds] The list of ids for messages
         * @param {string} [parkReason] The reason for parking the messages
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uiApiV2MessagesParkPost: function (messageIds, parkReason, options) {
            if (options === void 0) { options = {}; }
            var localVarPath = "/ui/api/v2/messages/park";
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign({ method: 'POST' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            // authentication oauth2 required
            // oauth required
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["partner-api-v2"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            if (messageIds) {
                localVarQueryParameter['messageIds'] = messageIds;
            }
            if (parkReason !== undefined) {
                localVarQueryParameter['parkReason'] = parkReason;
            }
            localVarUrlObj.query = __assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign({}, localVarHeaderParameter, options.headers);
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Retries the message based on its id
         * @param {Array<number>} [messageIds] The list of ids for messages to retry
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uiApiV2MessagesRetryPost: function (messageIds, options) {
            if (options === void 0) { options = {}; }
            var localVarPath = "/ui/api/v2/messages/retry";
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign({ method: 'POST' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            // authentication oauth2 required
            // oauth required
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["partner-api-v2"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            if (messageIds) {
                localVarQueryParameter['messageIds'] = messageIds;
            }
            localVarUrlObj.query = __assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign({}, localVarHeaderParameter, options.headers);
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Retries the message based on its id
         * @param {string} messageGuid Unique identifier for message to retry
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uiApiV2MessagesRetrySinglePost: function (messageGuid, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'messageGuid' is not null or undefined
            if (messageGuid === null || messageGuid === undefined) {
                throw new base_1.RequiredError('messageGuid', 'Required parameter messageGuid was null or undefined when calling uiApiV2MessagesRetrySinglePost.');
            }
            var localVarPath = "/ui/api/v2/messages/retry-single";
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign({ method: 'POST' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            // authentication oauth2 required
            // oauth required
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["partner-api-v2"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            if (messageGuid !== undefined) {
                localVarQueryParameter['messageGuid'] = messageGuid;
            }
            localVarUrlObj.query = __assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign({}, localVarHeaderParameter, options.headers);
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Sends a copy of a message
         * @param {string} messageGuid Unique identifier for message to send a copy of
         * @param {boolean} asRaw Specifies if copy should be sent as raw XML or not (as PDF)
         * @param {SendCopyOptions} [sendOptions] specifies the email, subject and notes
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uiApiV2MessagesSendCopyPost: function (messageGuid, asRaw, sendOptions, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'messageGuid' is not null or undefined
            if (messageGuid === null || messageGuid === undefined) {
                throw new base_1.RequiredError('messageGuid', 'Required parameter messageGuid was null or undefined when calling uiApiV2MessagesSendCopyPost.');
            }
            // verify required parameter 'asRaw' is not null or undefined
            if (asRaw === null || asRaw === undefined) {
                throw new base_1.RequiredError('asRaw', 'Required parameter asRaw was null or undefined when calling uiApiV2MessagesSendCopyPost.');
            }
            var localVarPath = "/ui/api/v2/messages/send-copy";
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign({ method: 'POST' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            // authentication oauth2 required
            // oauth required
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["partner-api-v2"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            if (messageGuid !== undefined) {
                localVarQueryParameter['messageGuid'] = messageGuid;
            }
            if (asRaw !== undefined) {
                localVarQueryParameter['asRaw'] = asRaw;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
            localVarUrlObj.query = __assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign({}, localVarHeaderParameter, options.headers);
            var needsSerialization = (typeof sendOptions !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data = needsSerialization ? JSON.stringify(sendOptions !== undefined ? sendOptions : {}) : (sendOptions || "");
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Retry a message service based on
         * @param {number} serviceId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uiApiV2MessagesServicesByServiceIdRetryPost: function (serviceId, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'serviceId' is not null or undefined
            if (serviceId === null || serviceId === undefined) {
                throw new base_1.RequiredError('serviceId', 'Required parameter serviceId was null or undefined when calling uiApiV2MessagesServicesByServiceIdRetryPost.');
            }
            var localVarPath = "/ui/api/v2/messages/services/{serviceId}/retry"
                .replace("{" + "serviceId" + "}", encodeURIComponent(String(serviceId)));
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign({ method: 'POST' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            // authentication oauth2 required
            // oauth required
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["partner-api-v2"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarUrlObj.query = __assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign({}, localVarHeaderParameter, options.headers);
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * UIMessageApi - functional programming interface
 * @export
 */
exports.UIMessageApiFp = function (configuration) {
    return {
        /**
         *
         * @summary Get the attributes connected to the GUID of a message.
         * @param {string} messageGuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uiApiV2MessagesByMessageGuidAttributesGet: function (messageGuid, options) {
            var localVarAxiosArgs = exports.UIMessageApiAxiosParamCreator(configuration).uiApiV2MessagesByMessageGuidAttributesGet(messageGuid, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = axios_1.default; }
                if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                var axiosRequestArgs = __assign({}, localVarAxiosArgs.options, { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @summary Deletes a message based on the GUID
         * @param {string} messageGuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uiApiV2MessagesByMessageGuidDelete: function (messageGuid, options) {
            var localVarAxiosArgs = exports.UIMessageApiAxiosParamCreator(configuration).uiApiV2MessagesByMessageGuidDelete(messageGuid, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = axios_1.default; }
                if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                var axiosRequestArgs = __assign({}, localVarAxiosArgs.options, { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @summary Get the logs connected to the GUID of a message paged
         * @param {string} messageGuid Guid of the message
         * @param {number} [offset]
         * @param {number} [limit]
         * @param {string} [ownerIdentifier] Owner Identifier of the message. Only use if Manager or Admin.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uiApiV2MessagesByMessageGuidLogsGet: function (messageGuid, offset, limit, ownerIdentifier, options) {
            var localVarAxiosArgs = exports.UIMessageApiAxiosParamCreator(configuration).uiApiV2MessagesByMessageGuidLogsGet(messageGuid, offset, limit, ownerIdentifier, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = axios_1.default; }
                if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                var axiosRequestArgs = __assign({}, localVarAxiosArgs.options, { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @summary Get the status connected to the GUID of a message, along with extended traces
         * @param {string} messageGuid Guid of the message
         * @param {string} [ownerIdentifier] Owner Identifier of the message. Only use if Manager or Admin or if the party can not be determined from the context.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uiApiV2MessagesByMessageGuidStatusGet: function (messageGuid, ownerIdentifier, options) {
            var localVarAxiosArgs = exports.UIMessageApiAxiosParamCreator(configuration).uiApiV2MessagesByMessageGuidStatusGet(messageGuid, ownerIdentifier, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = axios_1.default; }
                if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                var axiosRequestArgs = __assign({}, localVarAxiosArgs.options, { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @summary Get the traces connected to the GUID of a message
         * @param {string} messageGuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uiApiV2MessagesByMessageGuidTracesGet: function (messageGuid, options) {
            var localVarAxiosArgs = exports.UIMessageApiAxiosParamCreator(configuration).uiApiV2MessagesByMessageGuidTracesGet(messageGuid, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = axios_1.default; }
                if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                var axiosRequestArgs = __assign({}, localVarAxiosArgs.options, { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @summary Get a message formatted with a stylesheet.
         * @param {number} messageId Message Id of the message
         * @param {number} index Index of the attachment
         * @param {boolean} raw
         * @param {string} [lang] Requested languages, with fallback options e.g. \&#39;is,en\&#39;. Default is empty.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uiApiV2MessagesByMessageIdDocumentsByIndexViewGet: function (messageId, index, raw, lang, options) {
            var localVarAxiosArgs = exports.UIMessageApiAxiosParamCreator(configuration).uiApiV2MessagesByMessageIdDocumentsByIndexViewGet(messageId, index, raw, lang, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = axios_1.default; }
                if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                var axiosRequestArgs = __assign({}, localVarAxiosArgs.options, { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @summary Get the core document connected to the id of a message
         * @param {number} messageId Id of the message
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uiApiV2MessagesByMessageIdDocumentsCoreGet: function (messageId, options) {
            var localVarAxiosArgs = exports.UIMessageApiAxiosParamCreator(configuration).uiApiV2MessagesByMessageIdDocumentsCoreGet(messageId, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = axios_1.default; }
                if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                var axiosRequestArgs = __assign({}, localVarAxiosArgs.options, { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @summary Get the documents connected to the id of a message
         * @param {number} messageId Id of the message
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uiApiV2MessagesByMessageIdDocumentsGet: function (messageId, options) {
            var localVarAxiosArgs = exports.UIMessageApiAxiosParamCreator(configuration).uiApiV2MessagesByMessageIdDocumentsGet(messageId, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = axios_1.default; }
                if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                var axiosRequestArgs = __assign({}, localVarAxiosArgs.options, { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @summary Get the original document connected to the id of a message
         * @param {number} messageId Id of the message
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uiApiV2MessagesByMessageIdDocumentsOriginalGet: function (messageId, options) {
            var localVarAxiosArgs = exports.UIMessageApiAxiosParamCreator(configuration).uiApiV2MessagesByMessageIdDocumentsOriginalGet(messageId, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = axios_1.default; }
                if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                var axiosRequestArgs = __assign({}, localVarAxiosArgs.options, { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @summary Get the original document connected to the id of a message
         * @param {number} messageId Id of the message
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uiApiV2MessagesByMessageIdDocumentsTransformedGet: function (messageId, options) {
            var localVarAxiosArgs = exports.UIMessageApiAxiosParamCreator(configuration).uiApiV2MessagesByMessageIdDocumentsTransformedGet(messageId, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = axios_1.default; }
                if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                var axiosRequestArgs = __assign({}, localVarAxiosArgs.options, { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @summary Get a message based on its message Id
         * @param {number} messageId Message Id of the message
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uiApiV2MessagesByMessageIdGet: function (messageId, options) {
            var localVarAxiosArgs = exports.UIMessageApiAxiosParamCreator(configuration).uiApiV2MessagesByMessageIdGet(messageId, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = axios_1.default; }
                if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                var axiosRequestArgs = __assign({}, localVarAxiosArgs.options, { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @summary Get the services connected to the message Id of a message
         * @param {number} messageId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uiApiV2MessagesByMessageIdServicesGet: function (messageId, options) {
            var localVarAxiosArgs = exports.UIMessageApiAxiosParamCreator(configuration).uiApiV2MessagesByMessageIdServicesGet(messageId, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = axios_1.default; }
                if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                var axiosRequestArgs = __assign({}, localVarAxiosArgs.options, { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @summary Get the validations connected to the GUID of a message
         * @param {number} messageId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uiApiV2MessagesByMessageIdValidationsGet: function (messageId, options) {
            var localVarAxiosArgs = exports.UIMessageApiAxiosParamCreator(configuration).uiApiV2MessagesByMessageIdValidationsGet(messageId, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = axios_1.default; }
                if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                var axiosRequestArgs = __assign({}, localVarAxiosArgs.options, { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @summary Get all messages based on a filter paged.
         * @param {'NotSet' | 'Received' | 'Delivered' | 'Processed' | 'Failed' | 'PendingDelivery' | 'PendingProcessing' | 'Parked' | 'Logged' | 'LoggedFailed' | 'Retrying' | 'NotProcessing' | 'LoggedRelayed' | 'PendingReview' | 'PendingInformation'} [status]
         * @param {string} [transfer]
         * @param {string} [transactionGroup]
         * @param {Date} [timeReceivedFrom]
         * @param {Date} [timeReceivedTo]
         * @param {string} [sourcePartyIdentifier]
         * @param {string} [sinkPartyIdentifier]
         * @param {string} [ownerPartyIdentifier]
         * @param {string} [fromTextFilter]
         * @param {string} [toTextFilter]
         * @param {string} [messageReference]
         * @param {'MissingData' | 'Ignored' | 'Invalid' | 'Unknown' | 'Valid'} [validationStatus]
         * @param {number} [offset]
         * @param {number} [limit]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uiApiV2MessagesGet: function (status, transfer, transactionGroup, timeReceivedFrom, timeReceivedTo, sourcePartyIdentifier, sinkPartyIdentifier, ownerPartyIdentifier, fromTextFilter, toTextFilter, messageReference, validationStatus, offset, limit, options) {
            var localVarAxiosArgs = exports.UIMessageApiAxiosParamCreator(configuration).uiApiV2MessagesGet(status, transfer, transactionGroup, timeReceivedFrom, timeReceivedTo, sourcePartyIdentifier, sinkPartyIdentifier, ownerPartyIdentifier, fromTextFilter, toTextFilter, messageReference, validationStatus, offset, limit, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = axios_1.default; }
                if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                var axiosRequestArgs = __assign({}, localVarAxiosArgs.options, { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @summary Parks a message based on its id
         * @param {Array<number>} [messageIds] The list of ids for messages
         * @param {string} [parkReason] The reason for parking the messages
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uiApiV2MessagesParkPost: function (messageIds, parkReason, options) {
            var localVarAxiosArgs = exports.UIMessageApiAxiosParamCreator(configuration).uiApiV2MessagesParkPost(messageIds, parkReason, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = axios_1.default; }
                if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                var axiosRequestArgs = __assign({}, localVarAxiosArgs.options, { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @summary Retries the message based on its id
         * @param {Array<number>} [messageIds] The list of ids for messages to retry
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uiApiV2MessagesRetryPost: function (messageIds, options) {
            var localVarAxiosArgs = exports.UIMessageApiAxiosParamCreator(configuration).uiApiV2MessagesRetryPost(messageIds, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = axios_1.default; }
                if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                var axiosRequestArgs = __assign({}, localVarAxiosArgs.options, { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @summary Retries the message based on its id
         * @param {string} messageGuid Unique identifier for message to retry
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uiApiV2MessagesRetrySinglePost: function (messageGuid, options) {
            var localVarAxiosArgs = exports.UIMessageApiAxiosParamCreator(configuration).uiApiV2MessagesRetrySinglePost(messageGuid, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = axios_1.default; }
                if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                var axiosRequestArgs = __assign({}, localVarAxiosArgs.options, { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @summary Sends a copy of a message
         * @param {string} messageGuid Unique identifier for message to send a copy of
         * @param {boolean} asRaw Specifies if copy should be sent as raw XML or not (as PDF)
         * @param {SendCopyOptions} [sendOptions] specifies the email, subject and notes
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uiApiV2MessagesSendCopyPost: function (messageGuid, asRaw, sendOptions, options) {
            var localVarAxiosArgs = exports.UIMessageApiAxiosParamCreator(configuration).uiApiV2MessagesSendCopyPost(messageGuid, asRaw, sendOptions, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = axios_1.default; }
                if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                var axiosRequestArgs = __assign({}, localVarAxiosArgs.options, { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @summary Retry a message service based on
         * @param {number} serviceId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uiApiV2MessagesServicesByServiceIdRetryPost: function (serviceId, options) {
            var localVarAxiosArgs = exports.UIMessageApiAxiosParamCreator(configuration).uiApiV2MessagesServicesByServiceIdRetryPost(serviceId, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = axios_1.default; }
                if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                var axiosRequestArgs = __assign({}, localVarAxiosArgs.options, { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
    };
};
/**
 * UIMessageApi - factory interface
 * @export
 */
exports.UIMessageApiFactory = function (configuration, basePath, axios) {
    return {
        /**
         *
         * @summary Get the attributes connected to the GUID of a message.
         * @param {string} messageGuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uiApiV2MessagesByMessageGuidAttributesGet: function (messageGuid, options) {
            return exports.UIMessageApiFp(configuration).uiApiV2MessagesByMessageGuidAttributesGet(messageGuid, options)(axios, basePath);
        },
        /**
         *
         * @summary Deletes a message based on the GUID
         * @param {string} messageGuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uiApiV2MessagesByMessageGuidDelete: function (messageGuid, options) {
            return exports.UIMessageApiFp(configuration).uiApiV2MessagesByMessageGuidDelete(messageGuid, options)(axios, basePath);
        },
        /**
         *
         * @summary Get the logs connected to the GUID of a message paged
         * @param {string} messageGuid Guid of the message
         * @param {number} [offset]
         * @param {number} [limit]
         * @param {string} [ownerIdentifier] Owner Identifier of the message. Only use if Manager or Admin.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uiApiV2MessagesByMessageGuidLogsGet: function (messageGuid, offset, limit, ownerIdentifier, options) {
            return exports.UIMessageApiFp(configuration).uiApiV2MessagesByMessageGuidLogsGet(messageGuid, offset, limit, ownerIdentifier, options)(axios, basePath);
        },
        /**
         *
         * @summary Get the status connected to the GUID of a message, along with extended traces
         * @param {string} messageGuid Guid of the message
         * @param {string} [ownerIdentifier] Owner Identifier of the message. Only use if Manager or Admin or if the party can not be determined from the context.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uiApiV2MessagesByMessageGuidStatusGet: function (messageGuid, ownerIdentifier, options) {
            return exports.UIMessageApiFp(configuration).uiApiV2MessagesByMessageGuidStatusGet(messageGuid, ownerIdentifier, options)(axios, basePath);
        },
        /**
         *
         * @summary Get the traces connected to the GUID of a message
         * @param {string} messageGuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uiApiV2MessagesByMessageGuidTracesGet: function (messageGuid, options) {
            return exports.UIMessageApiFp(configuration).uiApiV2MessagesByMessageGuidTracesGet(messageGuid, options)(axios, basePath);
        },
        /**
         *
         * @summary Get a message formatted with a stylesheet.
         * @param {number} messageId Message Id of the message
         * @param {number} index Index of the attachment
         * @param {boolean} raw
         * @param {string} [lang] Requested languages, with fallback options e.g. \&#39;is,en\&#39;. Default is empty.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uiApiV2MessagesByMessageIdDocumentsByIndexViewGet: function (messageId, index, raw, lang, options) {
            return exports.UIMessageApiFp(configuration).uiApiV2MessagesByMessageIdDocumentsByIndexViewGet(messageId, index, raw, lang, options)(axios, basePath);
        },
        /**
         *
         * @summary Get the core document connected to the id of a message
         * @param {number} messageId Id of the message
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uiApiV2MessagesByMessageIdDocumentsCoreGet: function (messageId, options) {
            return exports.UIMessageApiFp(configuration).uiApiV2MessagesByMessageIdDocumentsCoreGet(messageId, options)(axios, basePath);
        },
        /**
         *
         * @summary Get the documents connected to the id of a message
         * @param {number} messageId Id of the message
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uiApiV2MessagesByMessageIdDocumentsGet: function (messageId, options) {
            return exports.UIMessageApiFp(configuration).uiApiV2MessagesByMessageIdDocumentsGet(messageId, options)(axios, basePath);
        },
        /**
         *
         * @summary Get the original document connected to the id of a message
         * @param {number} messageId Id of the message
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uiApiV2MessagesByMessageIdDocumentsOriginalGet: function (messageId, options) {
            return exports.UIMessageApiFp(configuration).uiApiV2MessagesByMessageIdDocumentsOriginalGet(messageId, options)(axios, basePath);
        },
        /**
         *
         * @summary Get the original document connected to the id of a message
         * @param {number} messageId Id of the message
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uiApiV2MessagesByMessageIdDocumentsTransformedGet: function (messageId, options) {
            return exports.UIMessageApiFp(configuration).uiApiV2MessagesByMessageIdDocumentsTransformedGet(messageId, options)(axios, basePath);
        },
        /**
         *
         * @summary Get a message based on its message Id
         * @param {number} messageId Message Id of the message
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uiApiV2MessagesByMessageIdGet: function (messageId, options) {
            return exports.UIMessageApiFp(configuration).uiApiV2MessagesByMessageIdGet(messageId, options)(axios, basePath);
        },
        /**
         *
         * @summary Get the services connected to the message Id of a message
         * @param {number} messageId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uiApiV2MessagesByMessageIdServicesGet: function (messageId, options) {
            return exports.UIMessageApiFp(configuration).uiApiV2MessagesByMessageIdServicesGet(messageId, options)(axios, basePath);
        },
        /**
         *
         * @summary Get the validations connected to the GUID of a message
         * @param {number} messageId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uiApiV2MessagesByMessageIdValidationsGet: function (messageId, options) {
            return exports.UIMessageApiFp(configuration).uiApiV2MessagesByMessageIdValidationsGet(messageId, options)(axios, basePath);
        },
        /**
         *
         * @summary Get all messages based on a filter paged.
         * @param {'NotSet' | 'Received' | 'Delivered' | 'Processed' | 'Failed' | 'PendingDelivery' | 'PendingProcessing' | 'Parked' | 'Logged' | 'LoggedFailed' | 'Retrying' | 'NotProcessing' | 'LoggedRelayed' | 'PendingReview' | 'PendingInformation'} [status]
         * @param {string} [transfer]
         * @param {string} [transactionGroup]
         * @param {Date} [timeReceivedFrom]
         * @param {Date} [timeReceivedTo]
         * @param {string} [sourcePartyIdentifier]
         * @param {string} [sinkPartyIdentifier]
         * @param {string} [ownerPartyIdentifier]
         * @param {string} [fromTextFilter]
         * @param {string} [toTextFilter]
         * @param {string} [messageReference]
         * @param {'MissingData' | 'Ignored' | 'Invalid' | 'Unknown' | 'Valid'} [validationStatus]
         * @param {number} [offset]
         * @param {number} [limit]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uiApiV2MessagesGet: function (status, transfer, transactionGroup, timeReceivedFrom, timeReceivedTo, sourcePartyIdentifier, sinkPartyIdentifier, ownerPartyIdentifier, fromTextFilter, toTextFilter, messageReference, validationStatus, offset, limit, options) {
            return exports.UIMessageApiFp(configuration).uiApiV2MessagesGet(status, transfer, transactionGroup, timeReceivedFrom, timeReceivedTo, sourcePartyIdentifier, sinkPartyIdentifier, ownerPartyIdentifier, fromTextFilter, toTextFilter, messageReference, validationStatus, offset, limit, options)(axios, basePath);
        },
        /**
         *
         * @summary Parks a message based on its id
         * @param {Array<number>} [messageIds] The list of ids for messages
         * @param {string} [parkReason] The reason for parking the messages
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uiApiV2MessagesParkPost: function (messageIds, parkReason, options) {
            return exports.UIMessageApiFp(configuration).uiApiV2MessagesParkPost(messageIds, parkReason, options)(axios, basePath);
        },
        /**
         *
         * @summary Retries the message based on its id
         * @param {Array<number>} [messageIds] The list of ids for messages to retry
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uiApiV2MessagesRetryPost: function (messageIds, options) {
            return exports.UIMessageApiFp(configuration).uiApiV2MessagesRetryPost(messageIds, options)(axios, basePath);
        },
        /**
         *
         * @summary Retries the message based on its id
         * @param {string} messageGuid Unique identifier for message to retry
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uiApiV2MessagesRetrySinglePost: function (messageGuid, options) {
            return exports.UIMessageApiFp(configuration).uiApiV2MessagesRetrySinglePost(messageGuid, options)(axios, basePath);
        },
        /**
         *
         * @summary Sends a copy of a message
         * @param {string} messageGuid Unique identifier for message to send a copy of
         * @param {boolean} asRaw Specifies if copy should be sent as raw XML or not (as PDF)
         * @param {SendCopyOptions} [sendOptions] specifies the email, subject and notes
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uiApiV2MessagesSendCopyPost: function (messageGuid, asRaw, sendOptions, options) {
            return exports.UIMessageApiFp(configuration).uiApiV2MessagesSendCopyPost(messageGuid, asRaw, sendOptions, options)(axios, basePath);
        },
        /**
         *
         * @summary Retry a message service based on
         * @param {number} serviceId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uiApiV2MessagesServicesByServiceIdRetryPost: function (serviceId, options) {
            return exports.UIMessageApiFp(configuration).uiApiV2MessagesServicesByServiceIdRetryPost(serviceId, options)(axios, basePath);
        },
    };
};
/**
 * UIMessageApi - object-oriented interface
 * @export
 * @class UIMessageApi
 * @extends {BaseAPI}
 */
var UIMessageApi = /** @class */ (function (_super) {
    __extends(UIMessageApi, _super);
    function UIMessageApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary Get the attributes connected to the GUID of a message.
     * @param {string} messageGuid
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UIMessageApi
     */
    UIMessageApi.prototype.uiApiV2MessagesByMessageGuidAttributesGet = function (messageGuid, options) {
        return exports.UIMessageApiFp(this.configuration).uiApiV2MessagesByMessageGuidAttributesGet(messageGuid, options)(this.axios, this.basePath);
    };
    /**
     *
     * @summary Deletes a message based on the GUID
     * @param {string} messageGuid
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UIMessageApi
     */
    UIMessageApi.prototype.uiApiV2MessagesByMessageGuidDelete = function (messageGuid, options) {
        return exports.UIMessageApiFp(this.configuration).uiApiV2MessagesByMessageGuidDelete(messageGuid, options)(this.axios, this.basePath);
    };
    /**
     *
     * @summary Get the logs connected to the GUID of a message paged
     * @param {string} messageGuid Guid of the message
     * @param {number} [offset]
     * @param {number} [limit]
     * @param {string} [ownerIdentifier] Owner Identifier of the message. Only use if Manager or Admin.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UIMessageApi
     */
    UIMessageApi.prototype.uiApiV2MessagesByMessageGuidLogsGet = function (messageGuid, offset, limit, ownerIdentifier, options) {
        return exports.UIMessageApiFp(this.configuration).uiApiV2MessagesByMessageGuidLogsGet(messageGuid, offset, limit, ownerIdentifier, options)(this.axios, this.basePath);
    };
    /**
     *
     * @summary Get the status connected to the GUID of a message, along with extended traces
     * @param {string} messageGuid Guid of the message
     * @param {string} [ownerIdentifier] Owner Identifier of the message. Only use if Manager or Admin or if the party can not be determined from the context.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UIMessageApi
     */
    UIMessageApi.prototype.uiApiV2MessagesByMessageGuidStatusGet = function (messageGuid, ownerIdentifier, options) {
        return exports.UIMessageApiFp(this.configuration).uiApiV2MessagesByMessageGuidStatusGet(messageGuid, ownerIdentifier, options)(this.axios, this.basePath);
    };
    /**
     *
     * @summary Get the traces connected to the GUID of a message
     * @param {string} messageGuid
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UIMessageApi
     */
    UIMessageApi.prototype.uiApiV2MessagesByMessageGuidTracesGet = function (messageGuid, options) {
        return exports.UIMessageApiFp(this.configuration).uiApiV2MessagesByMessageGuidTracesGet(messageGuid, options)(this.axios, this.basePath);
    };
    /**
     *
     * @summary Get a message formatted with a stylesheet.
     * @param {number} messageId Message Id of the message
     * @param {number} index Index of the attachment
     * @param {boolean} raw
     * @param {string} [lang] Requested languages, with fallback options e.g. \&#39;is,en\&#39;. Default is empty.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UIMessageApi
     */
    UIMessageApi.prototype.uiApiV2MessagesByMessageIdDocumentsByIndexViewGet = function (messageId, index, raw, lang, options) {
        return exports.UIMessageApiFp(this.configuration).uiApiV2MessagesByMessageIdDocumentsByIndexViewGet(messageId, index, raw, lang, options)(this.axios, this.basePath);
    };
    /**
     *
     * @summary Get the core document connected to the id of a message
     * @param {number} messageId Id of the message
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UIMessageApi
     */
    UIMessageApi.prototype.uiApiV2MessagesByMessageIdDocumentsCoreGet = function (messageId, options) {
        return exports.UIMessageApiFp(this.configuration).uiApiV2MessagesByMessageIdDocumentsCoreGet(messageId, options)(this.axios, this.basePath);
    };
    /**
     *
     * @summary Get the documents connected to the id of a message
     * @param {number} messageId Id of the message
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UIMessageApi
     */
    UIMessageApi.prototype.uiApiV2MessagesByMessageIdDocumentsGet = function (messageId, options) {
        return exports.UIMessageApiFp(this.configuration).uiApiV2MessagesByMessageIdDocumentsGet(messageId, options)(this.axios, this.basePath);
    };
    /**
     *
     * @summary Get the original document connected to the id of a message
     * @param {number} messageId Id of the message
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UIMessageApi
     */
    UIMessageApi.prototype.uiApiV2MessagesByMessageIdDocumentsOriginalGet = function (messageId, options) {
        return exports.UIMessageApiFp(this.configuration).uiApiV2MessagesByMessageIdDocumentsOriginalGet(messageId, options)(this.axios, this.basePath);
    };
    /**
     *
     * @summary Get the original document connected to the id of a message
     * @param {number} messageId Id of the message
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UIMessageApi
     */
    UIMessageApi.prototype.uiApiV2MessagesByMessageIdDocumentsTransformedGet = function (messageId, options) {
        return exports.UIMessageApiFp(this.configuration).uiApiV2MessagesByMessageIdDocumentsTransformedGet(messageId, options)(this.axios, this.basePath);
    };
    /**
     *
     * @summary Get a message based on its message Id
     * @param {number} messageId Message Id of the message
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UIMessageApi
     */
    UIMessageApi.prototype.uiApiV2MessagesByMessageIdGet = function (messageId, options) {
        return exports.UIMessageApiFp(this.configuration).uiApiV2MessagesByMessageIdGet(messageId, options)(this.axios, this.basePath);
    };
    /**
     *
     * @summary Get the services connected to the message Id of a message
     * @param {number} messageId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UIMessageApi
     */
    UIMessageApi.prototype.uiApiV2MessagesByMessageIdServicesGet = function (messageId, options) {
        return exports.UIMessageApiFp(this.configuration).uiApiV2MessagesByMessageIdServicesGet(messageId, options)(this.axios, this.basePath);
    };
    /**
     *
     * @summary Get the validations connected to the GUID of a message
     * @param {number} messageId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UIMessageApi
     */
    UIMessageApi.prototype.uiApiV2MessagesByMessageIdValidationsGet = function (messageId, options) {
        return exports.UIMessageApiFp(this.configuration).uiApiV2MessagesByMessageIdValidationsGet(messageId, options)(this.axios, this.basePath);
    };
    /**
     *
     * @summary Get all messages based on a filter paged.
     * @param {'NotSet' | 'Received' | 'Delivered' | 'Processed' | 'Failed' | 'PendingDelivery' | 'PendingProcessing' | 'Parked' | 'Logged' | 'LoggedFailed' | 'Retrying' | 'NotProcessing' | 'LoggedRelayed' | 'PendingReview' | 'PendingInformation'} [status]
     * @param {string} [transfer]
     * @param {string} [transactionGroup]
     * @param {Date} [timeReceivedFrom]
     * @param {Date} [timeReceivedTo]
     * @param {string} [sourcePartyIdentifier]
     * @param {string} [sinkPartyIdentifier]
     * @param {string} [ownerPartyIdentifier]
     * @param {string} [fromTextFilter]
     * @param {string} [toTextFilter]
     * @param {string} [messageReference]
     * @param {'MissingData' | 'Ignored' | 'Invalid' | 'Unknown' | 'Valid'} [validationStatus]
     * @param {number} [offset]
     * @param {number} [limit]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UIMessageApi
     */
    UIMessageApi.prototype.uiApiV2MessagesGet = function (status, transfer, transactionGroup, timeReceivedFrom, timeReceivedTo, sourcePartyIdentifier, sinkPartyIdentifier, ownerPartyIdentifier, fromTextFilter, toTextFilter, messageReference, validationStatus, offset, limit, options) {
        return exports.UIMessageApiFp(this.configuration).uiApiV2MessagesGet(status, transfer, transactionGroup, timeReceivedFrom, timeReceivedTo, sourcePartyIdentifier, sinkPartyIdentifier, ownerPartyIdentifier, fromTextFilter, toTextFilter, messageReference, validationStatus, offset, limit, options)(this.axios, this.basePath);
    };
    /**
     *
     * @summary Parks a message based on its id
     * @param {Array<number>} [messageIds] The list of ids for messages
     * @param {string} [parkReason] The reason for parking the messages
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UIMessageApi
     */
    UIMessageApi.prototype.uiApiV2MessagesParkPost = function (messageIds, parkReason, options) {
        return exports.UIMessageApiFp(this.configuration).uiApiV2MessagesParkPost(messageIds, parkReason, options)(this.axios, this.basePath);
    };
    /**
     *
     * @summary Retries the message based on its id
     * @param {Array<number>} [messageIds] The list of ids for messages to retry
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UIMessageApi
     */
    UIMessageApi.prototype.uiApiV2MessagesRetryPost = function (messageIds, options) {
        return exports.UIMessageApiFp(this.configuration).uiApiV2MessagesRetryPost(messageIds, options)(this.axios, this.basePath);
    };
    /**
     *
     * @summary Retries the message based on its id
     * @param {string} messageGuid Unique identifier for message to retry
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UIMessageApi
     */
    UIMessageApi.prototype.uiApiV2MessagesRetrySinglePost = function (messageGuid, options) {
        return exports.UIMessageApiFp(this.configuration).uiApiV2MessagesRetrySinglePost(messageGuid, options)(this.axios, this.basePath);
    };
    /**
     *
     * @summary Sends a copy of a message
     * @param {string} messageGuid Unique identifier for message to send a copy of
     * @param {boolean} asRaw Specifies if copy should be sent as raw XML or not (as PDF)
     * @param {SendCopyOptions} [sendOptions] specifies the email, subject and notes
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UIMessageApi
     */
    UIMessageApi.prototype.uiApiV2MessagesSendCopyPost = function (messageGuid, asRaw, sendOptions, options) {
        return exports.UIMessageApiFp(this.configuration).uiApiV2MessagesSendCopyPost(messageGuid, asRaw, sendOptions, options)(this.axios, this.basePath);
    };
    /**
     *
     * @summary Retry a message service based on
     * @param {number} serviceId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UIMessageApi
     */
    UIMessageApi.prototype.uiApiV2MessagesServicesByServiceIdRetryPost = function (serviceId, options) {
        return exports.UIMessageApiFp(this.configuration).uiApiV2MessagesServicesByServiceIdRetryPost(serviceId, options)(this.axios, this.basePath);
    };
    return UIMessageApi;
}(base_1.BaseAPI));
exports.UIMessageApi = UIMessageApi;
/**
 * UIMessageServicesApi - axios parameter creator
 * @export
 */
exports.UIMessageServicesApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Get all services based on a filter paged.
         * @param {string} [status]
         * @param {string} [partyIdentifier]
         * @param {Date} [fromTime]
         * @param {Date} [toTime]
         * @param {number} [offset]
         * @param {number} [limit]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uiApiV2ServicesGet: function (status, partyIdentifier, fromTime, toTime, offset, limit, options) {
            if (options === void 0) { options = {}; }
            var localVarPath = "/ui/api/v2/services";
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign({ method: 'GET' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            // authentication oauth2 required
            // oauth required
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["partner-api-v2"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            if (status !== undefined) {
                localVarQueryParameter['Status'] = status;
            }
            if (partyIdentifier !== undefined) {
                localVarQueryParameter['PartyIdentifier'] = partyIdentifier;
            }
            if (fromTime !== undefined) {
                localVarQueryParameter['FromTime'] = (fromTime instanceof Date) ?
                    fromTime.toISOString() :
                    fromTime;
            }
            if (toTime !== undefined) {
                localVarQueryParameter['ToTime'] = (toTime instanceof Date) ?
                    toTime.toISOString() :
                    toTime;
            }
            if (offset !== undefined) {
                localVarQueryParameter['Offset'] = offset;
            }
            if (limit !== undefined) {
                localVarQueryParameter['Limit'] = limit;
            }
            localVarUrlObj.query = __assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign({}, localVarHeaderParameter, options.headers);
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Parks the list of services based on ids
         * @param {Array<number>} [serviceIds]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uiApiV2ServicesParkPost: function (serviceIds, options) {
            if (options === void 0) { options = {}; }
            var localVarPath = "/ui/api/v2/services/park";
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign({ method: 'POST' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            // authentication oauth2 required
            // oauth required
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["partner-api-v2"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            if (serviceIds) {
                localVarQueryParameter['serviceIds'] = serviceIds;
            }
            localVarUrlObj.query = __assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign({}, localVarHeaderParameter, options.headers);
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Retries the list of services based on ids
         * @param {Array<number>} [serviceIds]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uiApiV2ServicesRetryPost: function (serviceIds, options) {
            if (options === void 0) { options = {}; }
            var localVarPath = "/ui/api/v2/services/retry";
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign({ method: 'POST' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            // authentication oauth2 required
            // oauth required
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["partner-api-v2"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            if (serviceIds) {
                localVarQueryParameter['serviceIds'] = serviceIds;
            }
            localVarUrlObj.query = __assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign({}, localVarHeaderParameter, options.headers);
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * UIMessageServicesApi - functional programming interface
 * @export
 */
exports.UIMessageServicesApiFp = function (configuration) {
    return {
        /**
         *
         * @summary Get all services based on a filter paged.
         * @param {string} [status]
         * @param {string} [partyIdentifier]
         * @param {Date} [fromTime]
         * @param {Date} [toTime]
         * @param {number} [offset]
         * @param {number} [limit]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uiApiV2ServicesGet: function (status, partyIdentifier, fromTime, toTime, offset, limit, options) {
            var localVarAxiosArgs = exports.UIMessageServicesApiAxiosParamCreator(configuration).uiApiV2ServicesGet(status, partyIdentifier, fromTime, toTime, offset, limit, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = axios_1.default; }
                if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                var axiosRequestArgs = __assign({}, localVarAxiosArgs.options, { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @summary Parks the list of services based on ids
         * @param {Array<number>} [serviceIds]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uiApiV2ServicesParkPost: function (serviceIds, options) {
            var localVarAxiosArgs = exports.UIMessageServicesApiAxiosParamCreator(configuration).uiApiV2ServicesParkPost(serviceIds, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = axios_1.default; }
                if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                var axiosRequestArgs = __assign({}, localVarAxiosArgs.options, { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @summary Retries the list of services based on ids
         * @param {Array<number>} [serviceIds]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uiApiV2ServicesRetryPost: function (serviceIds, options) {
            var localVarAxiosArgs = exports.UIMessageServicesApiAxiosParamCreator(configuration).uiApiV2ServicesRetryPost(serviceIds, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = axios_1.default; }
                if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                var axiosRequestArgs = __assign({}, localVarAxiosArgs.options, { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
    };
};
/**
 * UIMessageServicesApi - factory interface
 * @export
 */
exports.UIMessageServicesApiFactory = function (configuration, basePath, axios) {
    return {
        /**
         *
         * @summary Get all services based on a filter paged.
         * @param {string} [status]
         * @param {string} [partyIdentifier]
         * @param {Date} [fromTime]
         * @param {Date} [toTime]
         * @param {number} [offset]
         * @param {number} [limit]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uiApiV2ServicesGet: function (status, partyIdentifier, fromTime, toTime, offset, limit, options) {
            return exports.UIMessageServicesApiFp(configuration).uiApiV2ServicesGet(status, partyIdentifier, fromTime, toTime, offset, limit, options)(axios, basePath);
        },
        /**
         *
         * @summary Parks the list of services based on ids
         * @param {Array<number>} [serviceIds]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uiApiV2ServicesParkPost: function (serviceIds, options) {
            return exports.UIMessageServicesApiFp(configuration).uiApiV2ServicesParkPost(serviceIds, options)(axios, basePath);
        },
        /**
         *
         * @summary Retries the list of services based on ids
         * @param {Array<number>} [serviceIds]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uiApiV2ServicesRetryPost: function (serviceIds, options) {
            return exports.UIMessageServicesApiFp(configuration).uiApiV2ServicesRetryPost(serviceIds, options)(axios, basePath);
        },
    };
};
/**
 * UIMessageServicesApi - object-oriented interface
 * @export
 * @class UIMessageServicesApi
 * @extends {BaseAPI}
 */
var UIMessageServicesApi = /** @class */ (function (_super) {
    __extends(UIMessageServicesApi, _super);
    function UIMessageServicesApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary Get all services based on a filter paged.
     * @param {string} [status]
     * @param {string} [partyIdentifier]
     * @param {Date} [fromTime]
     * @param {Date} [toTime]
     * @param {number} [offset]
     * @param {number} [limit]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UIMessageServicesApi
     */
    UIMessageServicesApi.prototype.uiApiV2ServicesGet = function (status, partyIdentifier, fromTime, toTime, offset, limit, options) {
        return exports.UIMessageServicesApiFp(this.configuration).uiApiV2ServicesGet(status, partyIdentifier, fromTime, toTime, offset, limit, options)(this.axios, this.basePath);
    };
    /**
     *
     * @summary Parks the list of services based on ids
     * @param {Array<number>} [serviceIds]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UIMessageServicesApi
     */
    UIMessageServicesApi.prototype.uiApiV2ServicesParkPost = function (serviceIds, options) {
        return exports.UIMessageServicesApiFp(this.configuration).uiApiV2ServicesParkPost(serviceIds, options)(this.axios, this.basePath);
    };
    /**
     *
     * @summary Retries the list of services based on ids
     * @param {Array<number>} [serviceIds]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UIMessageServicesApi
     */
    UIMessageServicesApi.prototype.uiApiV2ServicesRetryPost = function (serviceIds, options) {
        return exports.UIMessageServicesApiFp(this.configuration).uiApiV2ServicesRetryPost(serviceIds, options)(this.axios, this.basePath);
    };
    return UIMessageServicesApi;
}(base_1.BaseAPI));
exports.UIMessageServicesApi = UIMessageServicesApi;
/**
 * UIPartyApi - axios parameter creator
 * @export
 */
exports.UIPartyApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Retrieves parties by their name or a substring of their name.
         * @param {boolean} showOnlyManaged Whether this query should show only managed parties
         * @param {string} [partialPartyName] The name of the party or the substring of it
         * @param {number} [offset]
         * @param {number} [limit]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uiApiV2PartiesGet: function (showOnlyManaged, partialPartyName, offset, limit, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'showOnlyManaged' is not null or undefined
            if (showOnlyManaged === null || showOnlyManaged === undefined) {
                throw new base_1.RequiredError('showOnlyManaged', 'Required parameter showOnlyManaged was null or undefined when calling uiApiV2PartiesGet.');
            }
            var localVarPath = "/ui/api/v2/parties";
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign({ method: 'GET' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            // authentication oauth2 required
            // oauth required
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["partner-api-v2"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            if (partialPartyName !== undefined) {
                localVarQueryParameter['partialPartyName'] = partialPartyName;
            }
            if (showOnlyManaged !== undefined) {
                localVarQueryParameter['showOnlyManaged'] = showOnlyManaged;
            }
            if (offset !== undefined) {
                localVarQueryParameter['Offset'] = offset;
            }
            if (limit !== undefined) {
                localVarQueryParameter['Limit'] = limit;
            }
            localVarUrlObj.query = __assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign({}, localVarHeaderParameter, options.headers);
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * UIPartyApi - functional programming interface
 * @export
 */
exports.UIPartyApiFp = function (configuration) {
    return {
        /**
         *
         * @summary Retrieves parties by their name or a substring of their name.
         * @param {boolean} showOnlyManaged Whether this query should show only managed parties
         * @param {string} [partialPartyName] The name of the party or the substring of it
         * @param {number} [offset]
         * @param {number} [limit]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uiApiV2PartiesGet: function (showOnlyManaged, partialPartyName, offset, limit, options) {
            var localVarAxiosArgs = exports.UIPartyApiAxiosParamCreator(configuration).uiApiV2PartiesGet(showOnlyManaged, partialPartyName, offset, limit, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = axios_1.default; }
                if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                var axiosRequestArgs = __assign({}, localVarAxiosArgs.options, { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
    };
};
/**
 * UIPartyApi - factory interface
 * @export
 */
exports.UIPartyApiFactory = function (configuration, basePath, axios) {
    return {
        /**
         *
         * @summary Retrieves parties by their name or a substring of their name.
         * @param {boolean} showOnlyManaged Whether this query should show only managed parties
         * @param {string} [partialPartyName] The name of the party or the substring of it
         * @param {number} [offset]
         * @param {number} [limit]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uiApiV2PartiesGet: function (showOnlyManaged, partialPartyName, offset, limit, options) {
            return exports.UIPartyApiFp(configuration).uiApiV2PartiesGet(showOnlyManaged, partialPartyName, offset, limit, options)(axios, basePath);
        },
    };
};
/**
 * UIPartyApi - object-oriented interface
 * @export
 * @class UIPartyApi
 * @extends {BaseAPI}
 */
var UIPartyApi = /** @class */ (function (_super) {
    __extends(UIPartyApi, _super);
    function UIPartyApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary Retrieves parties by their name or a substring of their name.
     * @param {boolean} showOnlyManaged Whether this query should show only managed parties
     * @param {string} [partialPartyName] The name of the party or the substring of it
     * @param {number} [offset]
     * @param {number} [limit]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UIPartyApi
     */
    UIPartyApi.prototype.uiApiV2PartiesGet = function (showOnlyManaged, partialPartyName, offset, limit, options) {
        return exports.UIPartyApiFp(this.configuration).uiApiV2PartiesGet(showOnlyManaged, partialPartyName, offset, limit, options)(this.axios, this.basePath);
    };
    return UIPartyApi;
}(base_1.BaseAPI));
exports.UIPartyApi = UIPartyApi;
/**
 * UIRegistrationApi - axios parameter creator
 * @export
 */
exports.UIRegistrationApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Get latest inconsistencies.
         * @param {string} managingPartnerIdentifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2PartnersByManagingPartnerIdentifierRegistrationInconsistenciesLatestGet: function (managingPartnerIdentifier, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'managingPartnerIdentifier' is not null or undefined
            if (managingPartnerIdentifier === null || managingPartnerIdentifier === undefined) {
                throw new base_1.RequiredError('managingPartnerIdentifier', 'Required parameter managingPartnerIdentifier was null or undefined when calling apiV2PartnersByManagingPartnerIdentifierRegistrationInconsistenciesLatestGet.');
            }
            var localVarPath = "/api/v2/partners/{managingPartnerIdentifier}/registrationInconsistencies/latest"
                .replace("{" + "managingPartnerIdentifier" + "}", encodeURIComponent(String(managingPartnerIdentifier)));
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign({ method: 'GET' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            // authentication oauth2 required
            // oauth required
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["partner-api-v2"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarUrlObj.query = __assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign({}, localVarHeaderParameter, options.headers);
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Returns parties managed by specific partner (by partner id).
         * @param {string} partnerIdentifier
         * @param {string} identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2PartnersByPartnerIdentifierParticipantsByIdentifierRegistrationGet: function (partnerIdentifier, identifier, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'partnerIdentifier' is not null or undefined
            if (partnerIdentifier === null || partnerIdentifier === undefined) {
                throw new base_1.RequiredError('partnerIdentifier', 'Required parameter partnerIdentifier was null or undefined when calling apiV2PartnersByPartnerIdentifierParticipantsByIdentifierRegistrationGet.');
            }
            // verify required parameter 'identifier' is not null or undefined
            if (identifier === null || identifier === undefined) {
                throw new base_1.RequiredError('identifier', 'Required parameter identifier was null or undefined when calling apiV2PartnersByPartnerIdentifierParticipantsByIdentifierRegistrationGet.');
            }
            var localVarPath = "/api/v2/partners/{partnerIdentifier}/participants/{identifier}/registration"
                .replace("{" + "partnerIdentifier" + "}", encodeURIComponent(String(partnerIdentifier)))
                .replace("{" + "identifier" + "}", encodeURIComponent(String(identifier)));
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign({ method: 'GET' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            // authentication oauth2 required
            // oauth required
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["partner-api-v2"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarUrlObj.query = __assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign({}, localVarHeaderParameter, options.headers);
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Returns parties managed by specific partner (by partner id).
         * @param {string} partnerIdentifier
         * @param {string} identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2PartnersByPartnerIdentifierParticipantsByIdentifierRegistrationInconsistenciesGet: function (partnerIdentifier, identifier, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'partnerIdentifier' is not null or undefined
            if (partnerIdentifier === null || partnerIdentifier === undefined) {
                throw new base_1.RequiredError('partnerIdentifier', 'Required parameter partnerIdentifier was null or undefined when calling apiV2PartnersByPartnerIdentifierParticipantsByIdentifierRegistrationInconsistenciesGet.');
            }
            // verify required parameter 'identifier' is not null or undefined
            if (identifier === null || identifier === undefined) {
                throw new base_1.RequiredError('identifier', 'Required parameter identifier was null or undefined when calling apiV2PartnersByPartnerIdentifierParticipantsByIdentifierRegistrationInconsistenciesGet.');
            }
            var localVarPath = "/api/v2/partners/{partnerIdentifier}/participants/{identifier}/registrationInconsistencies"
                .replace("{" + "partnerIdentifier" + "}", encodeURIComponent(String(partnerIdentifier)))
                .replace("{" + "identifier" + "}", encodeURIComponent(String(identifier)));
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign({ method: 'GET' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            // authentication oauth2 required
            // oauth required
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["partner-api-v2"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarUrlObj.query = __assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign({}, localVarHeaderParameter, options.headers);
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get registration status of participant.
         * @param {string} partnerIdentifier
         * @param {string} identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2PartnersByPartnerIdentifierParticipantsByIdentifierRegistrationstatusGet: function (partnerIdentifier, identifier, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'partnerIdentifier' is not null or undefined
            if (partnerIdentifier === null || partnerIdentifier === undefined) {
                throw new base_1.RequiredError('partnerIdentifier', 'Required parameter partnerIdentifier was null or undefined when calling apiV2PartnersByPartnerIdentifierParticipantsByIdentifierRegistrationstatusGet.');
            }
            // verify required parameter 'identifier' is not null or undefined
            if (identifier === null || identifier === undefined) {
                throw new base_1.RequiredError('identifier', 'Required parameter identifier was null or undefined when calling apiV2PartnersByPartnerIdentifierParticipantsByIdentifierRegistrationstatusGet.');
            }
            var localVarPath = "/api/v2/partners/{partnerIdentifier}/participants/{identifier}/registrationstatus"
                .replace("{" + "partnerIdentifier" + "}", encodeURIComponent(String(partnerIdentifier)))
                .replace("{" + "identifier" + "}", encodeURIComponent(String(identifier)));
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign({ method: 'GET' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            // authentication oauth2 required
            // oauth required
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["partner-api-v2"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarUrlObj.query = __assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign({}, localVarHeaderParameter, options.headers);
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary DeRegister specific transaction for a participant to an endpoint.
         * @param {string} partnerIdentifier
         * @param {string} identifier
         * @param {string} [transactionKeyName]
         * @param {Array<string>} [types]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2PartnersByPartnerIdentifierParticipantsByIdentifierTransactionsDelete: function (partnerIdentifier, identifier, transactionKeyName, types, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'partnerIdentifier' is not null or undefined
            if (partnerIdentifier === null || partnerIdentifier === undefined) {
                throw new base_1.RequiredError('partnerIdentifier', 'Required parameter partnerIdentifier was null or undefined when calling apiV2PartnersByPartnerIdentifierParticipantsByIdentifierTransactionsDelete.');
            }
            // verify required parameter 'identifier' is not null or undefined
            if (identifier === null || identifier === undefined) {
                throw new base_1.RequiredError('identifier', 'Required parameter identifier was null or undefined when calling apiV2PartnersByPartnerIdentifierParticipantsByIdentifierTransactionsDelete.');
            }
            var localVarPath = "/api/v2/partners/{partnerIdentifier}/participants/{identifier}/transactions"
                .replace("{" + "partnerIdentifier" + "}", encodeURIComponent(String(partnerIdentifier)))
                .replace("{" + "identifier" + "}", encodeURIComponent(String(identifier)));
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign({ method: 'DELETE' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            // authentication oauth2 required
            // oauth required
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["partner-api-v2"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            if (transactionKeyName !== undefined) {
                localVarQueryParameter['transactionKeyName'] = transactionKeyName;
            }
            if (types) {
                localVarQueryParameter['types'] = types;
            }
            localVarUrlObj.query = __assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign({}, localVarHeaderParameter, options.headers);
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Register specific transaction for a participant to an endpoint.
         * @param {string} partnerIdentifier
         * @param {string} identifier
         * @param {string} [transactionKeyName]
         * @param {Array<string>} [types]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2PartnersByPartnerIdentifierParticipantsByIdentifierTransactionsPut: function (partnerIdentifier, identifier, transactionKeyName, types, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'partnerIdentifier' is not null or undefined
            if (partnerIdentifier === null || partnerIdentifier === undefined) {
                throw new base_1.RequiredError('partnerIdentifier', 'Required parameter partnerIdentifier was null or undefined when calling apiV2PartnersByPartnerIdentifierParticipantsByIdentifierTransactionsPut.');
            }
            // verify required parameter 'identifier' is not null or undefined
            if (identifier === null || identifier === undefined) {
                throw new base_1.RequiredError('identifier', 'Required parameter identifier was null or undefined when calling apiV2PartnersByPartnerIdentifierParticipantsByIdentifierTransactionsPut.');
            }
            var localVarPath = "/api/v2/partners/{partnerIdentifier}/participants/{identifier}/transactions"
                .replace("{" + "partnerIdentifier" + "}", encodeURIComponent(String(partnerIdentifier)))
                .replace("{" + "identifier" + "}", encodeURIComponent(String(identifier)));
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign({ method: 'PUT' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            // authentication oauth2 required
            // oauth required
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["partner-api-v2"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            if (transactionKeyName !== undefined) {
                localVarQueryParameter['transactionKeyName'] = transactionKeyName;
            }
            if (types) {
                localVarQueryParameter['types'] = types;
            }
            localVarUrlObj.query = __assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign({}, localVarHeaderParameter, options.headers);
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Gets a list of managed parties and business transactions along with registrations.
         * @param {string} partnerIdentifier
         * @param {number} [offset]
         * @param {number} [limit]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2PartnersByPartnerIdentifierParticipantsRegistrationGet: function (partnerIdentifier, offset, limit, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'partnerIdentifier' is not null or undefined
            if (partnerIdentifier === null || partnerIdentifier === undefined) {
                throw new base_1.RequiredError('partnerIdentifier', 'Required parameter partnerIdentifier was null or undefined when calling apiV2PartnersByPartnerIdentifierParticipantsRegistrationGet.');
            }
            var localVarPath = "/api/v2/partners/{partnerIdentifier}/participants/registration"
                .replace("{" + "partnerIdentifier" + "}", encodeURIComponent(String(partnerIdentifier)));
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign({ method: 'GET' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            // authentication oauth2 required
            // oauth required
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["partner-api-v2"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            if (offset !== undefined) {
                localVarQueryParameter['Offset'] = offset;
            }
            if (limit !== undefined) {
                localVarQueryParameter['Limit'] = limit;
            }
            localVarUrlObj.query = __assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign({}, localVarHeaderParameter, options.headers);
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Gets a list of managed parties and business transactions along with registrations.
         * @param {string} partnerIdentifier
         * @param {number} [offset]
         * @param {number} [limit]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2PartnersByPartnerIdentifierParticipantsRegistrationInconsistenciesGet: function (partnerIdentifier, offset, limit, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'partnerIdentifier' is not null or undefined
            if (partnerIdentifier === null || partnerIdentifier === undefined) {
                throw new base_1.RequiredError('partnerIdentifier', 'Required parameter partnerIdentifier was null or undefined when calling apiV2PartnersByPartnerIdentifierParticipantsRegistrationInconsistenciesGet.');
            }
            var localVarPath = "/api/v2/partners/{partnerIdentifier}/participants/registrationInconsistencies"
                .replace("{" + "partnerIdentifier" + "}", encodeURIComponent(String(partnerIdentifier)));
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign({ method: 'GET' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            // authentication oauth2 required
            // oauth required
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["partner-api-v2"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            if (offset !== undefined) {
                localVarQueryParameter['Offset'] = offset;
            }
            if (limit !== undefined) {
                localVarQueryParameter['Limit'] = limit;
            }
            localVarUrlObj.query = __assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign({}, localVarHeaderParameter, options.headers);
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * UIRegistrationApi - functional programming interface
 * @export
 */
exports.UIRegistrationApiFp = function (configuration) {
    return {
        /**
         *
         * @summary Get latest inconsistencies.
         * @param {string} managingPartnerIdentifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2PartnersByManagingPartnerIdentifierRegistrationInconsistenciesLatestGet: function (managingPartnerIdentifier, options) {
            var localVarAxiosArgs = exports.UIRegistrationApiAxiosParamCreator(configuration).apiV2PartnersByManagingPartnerIdentifierRegistrationInconsistenciesLatestGet(managingPartnerIdentifier, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = axios_1.default; }
                if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                var axiosRequestArgs = __assign({}, localVarAxiosArgs.options, { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @summary Returns parties managed by specific partner (by partner id).
         * @param {string} partnerIdentifier
         * @param {string} identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2PartnersByPartnerIdentifierParticipantsByIdentifierRegistrationGet: function (partnerIdentifier, identifier, options) {
            var localVarAxiosArgs = exports.UIRegistrationApiAxiosParamCreator(configuration).apiV2PartnersByPartnerIdentifierParticipantsByIdentifierRegistrationGet(partnerIdentifier, identifier, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = axios_1.default; }
                if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                var axiosRequestArgs = __assign({}, localVarAxiosArgs.options, { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @summary Returns parties managed by specific partner (by partner id).
         * @param {string} partnerIdentifier
         * @param {string} identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2PartnersByPartnerIdentifierParticipantsByIdentifierRegistrationInconsistenciesGet: function (partnerIdentifier, identifier, options) {
            var localVarAxiosArgs = exports.UIRegistrationApiAxiosParamCreator(configuration).apiV2PartnersByPartnerIdentifierParticipantsByIdentifierRegistrationInconsistenciesGet(partnerIdentifier, identifier, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = axios_1.default; }
                if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                var axiosRequestArgs = __assign({}, localVarAxiosArgs.options, { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @summary Get registration status of participant.
         * @param {string} partnerIdentifier
         * @param {string} identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2PartnersByPartnerIdentifierParticipantsByIdentifierRegistrationstatusGet: function (partnerIdentifier, identifier, options) {
            var localVarAxiosArgs = exports.UIRegistrationApiAxiosParamCreator(configuration).apiV2PartnersByPartnerIdentifierParticipantsByIdentifierRegistrationstatusGet(partnerIdentifier, identifier, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = axios_1.default; }
                if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                var axiosRequestArgs = __assign({}, localVarAxiosArgs.options, { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @summary DeRegister specific transaction for a participant to an endpoint.
         * @param {string} partnerIdentifier
         * @param {string} identifier
         * @param {string} [transactionKeyName]
         * @param {Array<string>} [types]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2PartnersByPartnerIdentifierParticipantsByIdentifierTransactionsDelete: function (partnerIdentifier, identifier, transactionKeyName, types, options) {
            var localVarAxiosArgs = exports.UIRegistrationApiAxiosParamCreator(configuration).apiV2PartnersByPartnerIdentifierParticipantsByIdentifierTransactionsDelete(partnerIdentifier, identifier, transactionKeyName, types, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = axios_1.default; }
                if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                var axiosRequestArgs = __assign({}, localVarAxiosArgs.options, { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @summary Register specific transaction for a participant to an endpoint.
         * @param {string} partnerIdentifier
         * @param {string} identifier
         * @param {string} [transactionKeyName]
         * @param {Array<string>} [types]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2PartnersByPartnerIdentifierParticipantsByIdentifierTransactionsPut: function (partnerIdentifier, identifier, transactionKeyName, types, options) {
            var localVarAxiosArgs = exports.UIRegistrationApiAxiosParamCreator(configuration).apiV2PartnersByPartnerIdentifierParticipantsByIdentifierTransactionsPut(partnerIdentifier, identifier, transactionKeyName, types, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = axios_1.default; }
                if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                var axiosRequestArgs = __assign({}, localVarAxiosArgs.options, { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @summary Gets a list of managed parties and business transactions along with registrations.
         * @param {string} partnerIdentifier
         * @param {number} [offset]
         * @param {number} [limit]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2PartnersByPartnerIdentifierParticipantsRegistrationGet: function (partnerIdentifier, offset, limit, options) {
            var localVarAxiosArgs = exports.UIRegistrationApiAxiosParamCreator(configuration).apiV2PartnersByPartnerIdentifierParticipantsRegistrationGet(partnerIdentifier, offset, limit, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = axios_1.default; }
                if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                var axiosRequestArgs = __assign({}, localVarAxiosArgs.options, { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @summary Gets a list of managed parties and business transactions along with registrations.
         * @param {string} partnerIdentifier
         * @param {number} [offset]
         * @param {number} [limit]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2PartnersByPartnerIdentifierParticipantsRegistrationInconsistenciesGet: function (partnerIdentifier, offset, limit, options) {
            var localVarAxiosArgs = exports.UIRegistrationApiAxiosParamCreator(configuration).apiV2PartnersByPartnerIdentifierParticipantsRegistrationInconsistenciesGet(partnerIdentifier, offset, limit, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = axios_1.default; }
                if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                var axiosRequestArgs = __assign({}, localVarAxiosArgs.options, { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
    };
};
/**
 * UIRegistrationApi - factory interface
 * @export
 */
exports.UIRegistrationApiFactory = function (configuration, basePath, axios) {
    return {
        /**
         *
         * @summary Get latest inconsistencies.
         * @param {string} managingPartnerIdentifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2PartnersByManagingPartnerIdentifierRegistrationInconsistenciesLatestGet: function (managingPartnerIdentifier, options) {
            return exports.UIRegistrationApiFp(configuration).apiV2PartnersByManagingPartnerIdentifierRegistrationInconsistenciesLatestGet(managingPartnerIdentifier, options)(axios, basePath);
        },
        /**
         *
         * @summary Returns parties managed by specific partner (by partner id).
         * @param {string} partnerIdentifier
         * @param {string} identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2PartnersByPartnerIdentifierParticipantsByIdentifierRegistrationGet: function (partnerIdentifier, identifier, options) {
            return exports.UIRegistrationApiFp(configuration).apiV2PartnersByPartnerIdentifierParticipantsByIdentifierRegistrationGet(partnerIdentifier, identifier, options)(axios, basePath);
        },
        /**
         *
         * @summary Returns parties managed by specific partner (by partner id).
         * @param {string} partnerIdentifier
         * @param {string} identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2PartnersByPartnerIdentifierParticipantsByIdentifierRegistrationInconsistenciesGet: function (partnerIdentifier, identifier, options) {
            return exports.UIRegistrationApiFp(configuration).apiV2PartnersByPartnerIdentifierParticipantsByIdentifierRegistrationInconsistenciesGet(partnerIdentifier, identifier, options)(axios, basePath);
        },
        /**
         *
         * @summary Get registration status of participant.
         * @param {string} partnerIdentifier
         * @param {string} identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2PartnersByPartnerIdentifierParticipantsByIdentifierRegistrationstatusGet: function (partnerIdentifier, identifier, options) {
            return exports.UIRegistrationApiFp(configuration).apiV2PartnersByPartnerIdentifierParticipantsByIdentifierRegistrationstatusGet(partnerIdentifier, identifier, options)(axios, basePath);
        },
        /**
         *
         * @summary DeRegister specific transaction for a participant to an endpoint.
         * @param {string} partnerIdentifier
         * @param {string} identifier
         * @param {string} [transactionKeyName]
         * @param {Array<string>} [types]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2PartnersByPartnerIdentifierParticipantsByIdentifierTransactionsDelete: function (partnerIdentifier, identifier, transactionKeyName, types, options) {
            return exports.UIRegistrationApiFp(configuration).apiV2PartnersByPartnerIdentifierParticipantsByIdentifierTransactionsDelete(partnerIdentifier, identifier, transactionKeyName, types, options)(axios, basePath);
        },
        /**
         *
         * @summary Register specific transaction for a participant to an endpoint.
         * @param {string} partnerIdentifier
         * @param {string} identifier
         * @param {string} [transactionKeyName]
         * @param {Array<string>} [types]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2PartnersByPartnerIdentifierParticipantsByIdentifierTransactionsPut: function (partnerIdentifier, identifier, transactionKeyName, types, options) {
            return exports.UIRegistrationApiFp(configuration).apiV2PartnersByPartnerIdentifierParticipantsByIdentifierTransactionsPut(partnerIdentifier, identifier, transactionKeyName, types, options)(axios, basePath);
        },
        /**
         *
         * @summary Gets a list of managed parties and business transactions along with registrations.
         * @param {string} partnerIdentifier
         * @param {number} [offset]
         * @param {number} [limit]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2PartnersByPartnerIdentifierParticipantsRegistrationGet: function (partnerIdentifier, offset, limit, options) {
            return exports.UIRegistrationApiFp(configuration).apiV2PartnersByPartnerIdentifierParticipantsRegistrationGet(partnerIdentifier, offset, limit, options)(axios, basePath);
        },
        /**
         *
         * @summary Gets a list of managed parties and business transactions along with registrations.
         * @param {string} partnerIdentifier
         * @param {number} [offset]
         * @param {number} [limit]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2PartnersByPartnerIdentifierParticipantsRegistrationInconsistenciesGet: function (partnerIdentifier, offset, limit, options) {
            return exports.UIRegistrationApiFp(configuration).apiV2PartnersByPartnerIdentifierParticipantsRegistrationInconsistenciesGet(partnerIdentifier, offset, limit, options)(axios, basePath);
        },
    };
};
/**
 * UIRegistrationApi - object-oriented interface
 * @export
 * @class UIRegistrationApi
 * @extends {BaseAPI}
 */
var UIRegistrationApi = /** @class */ (function (_super) {
    __extends(UIRegistrationApi, _super);
    function UIRegistrationApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary Get latest inconsistencies.
     * @param {string} managingPartnerIdentifier
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UIRegistrationApi
     */
    UIRegistrationApi.prototype.apiV2PartnersByManagingPartnerIdentifierRegistrationInconsistenciesLatestGet = function (managingPartnerIdentifier, options) {
        return exports.UIRegistrationApiFp(this.configuration).apiV2PartnersByManagingPartnerIdentifierRegistrationInconsistenciesLatestGet(managingPartnerIdentifier, options)(this.axios, this.basePath);
    };
    /**
     *
     * @summary Returns parties managed by specific partner (by partner id).
     * @param {string} partnerIdentifier
     * @param {string} identifier
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UIRegistrationApi
     */
    UIRegistrationApi.prototype.apiV2PartnersByPartnerIdentifierParticipantsByIdentifierRegistrationGet = function (partnerIdentifier, identifier, options) {
        return exports.UIRegistrationApiFp(this.configuration).apiV2PartnersByPartnerIdentifierParticipantsByIdentifierRegistrationGet(partnerIdentifier, identifier, options)(this.axios, this.basePath);
    };
    /**
     *
     * @summary Returns parties managed by specific partner (by partner id).
     * @param {string} partnerIdentifier
     * @param {string} identifier
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UIRegistrationApi
     */
    UIRegistrationApi.prototype.apiV2PartnersByPartnerIdentifierParticipantsByIdentifierRegistrationInconsistenciesGet = function (partnerIdentifier, identifier, options) {
        return exports.UIRegistrationApiFp(this.configuration).apiV2PartnersByPartnerIdentifierParticipantsByIdentifierRegistrationInconsistenciesGet(partnerIdentifier, identifier, options)(this.axios, this.basePath);
    };
    /**
     *
     * @summary Get registration status of participant.
     * @param {string} partnerIdentifier
     * @param {string} identifier
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UIRegistrationApi
     */
    UIRegistrationApi.prototype.apiV2PartnersByPartnerIdentifierParticipantsByIdentifierRegistrationstatusGet = function (partnerIdentifier, identifier, options) {
        return exports.UIRegistrationApiFp(this.configuration).apiV2PartnersByPartnerIdentifierParticipantsByIdentifierRegistrationstatusGet(partnerIdentifier, identifier, options)(this.axios, this.basePath);
    };
    /**
     *
     * @summary DeRegister specific transaction for a participant to an endpoint.
     * @param {string} partnerIdentifier
     * @param {string} identifier
     * @param {string} [transactionKeyName]
     * @param {Array<string>} [types]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UIRegistrationApi
     */
    UIRegistrationApi.prototype.apiV2PartnersByPartnerIdentifierParticipantsByIdentifierTransactionsDelete = function (partnerIdentifier, identifier, transactionKeyName, types, options) {
        return exports.UIRegistrationApiFp(this.configuration).apiV2PartnersByPartnerIdentifierParticipantsByIdentifierTransactionsDelete(partnerIdentifier, identifier, transactionKeyName, types, options)(this.axios, this.basePath);
    };
    /**
     *
     * @summary Register specific transaction for a participant to an endpoint.
     * @param {string} partnerIdentifier
     * @param {string} identifier
     * @param {string} [transactionKeyName]
     * @param {Array<string>} [types]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UIRegistrationApi
     */
    UIRegistrationApi.prototype.apiV2PartnersByPartnerIdentifierParticipantsByIdentifierTransactionsPut = function (partnerIdentifier, identifier, transactionKeyName, types, options) {
        return exports.UIRegistrationApiFp(this.configuration).apiV2PartnersByPartnerIdentifierParticipantsByIdentifierTransactionsPut(partnerIdentifier, identifier, transactionKeyName, types, options)(this.axios, this.basePath);
    };
    /**
     *
     * @summary Gets a list of managed parties and business transactions along with registrations.
     * @param {string} partnerIdentifier
     * @param {number} [offset]
     * @param {number} [limit]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UIRegistrationApi
     */
    UIRegistrationApi.prototype.apiV2PartnersByPartnerIdentifierParticipantsRegistrationGet = function (partnerIdentifier, offset, limit, options) {
        return exports.UIRegistrationApiFp(this.configuration).apiV2PartnersByPartnerIdentifierParticipantsRegistrationGet(partnerIdentifier, offset, limit, options)(this.axios, this.basePath);
    };
    /**
     *
     * @summary Gets a list of managed parties and business transactions along with registrations.
     * @param {string} partnerIdentifier
     * @param {number} [offset]
     * @param {number} [limit]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UIRegistrationApi
     */
    UIRegistrationApi.prototype.apiV2PartnersByPartnerIdentifierParticipantsRegistrationInconsistenciesGet = function (partnerIdentifier, offset, limit, options) {
        return exports.UIRegistrationApiFp(this.configuration).apiV2PartnersByPartnerIdentifierParticipantsRegistrationInconsistenciesGet(partnerIdentifier, offset, limit, options)(this.axios, this.basePath);
    };
    return UIRegistrationApi;
}(base_1.BaseAPI));
exports.UIRegistrationApi = UIRegistrationApi;
/**
 * UiRelayApi - axios parameter creator
 * @export
 */
exports.UiRelayApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {CreateRelayUserInput} [input]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2RelayUsersPost: function (input, options) {
            if (options === void 0) { options = {}; }
            var localVarPath = "/api/v2/relay/users";
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign({ method: 'POST' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
            localVarUrlObj.query = __assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign({}, localVarHeaderParameter, options.headers);
            var needsSerialization = (typeof input !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data = needsSerialization ? JSON.stringify(input !== undefined ? input : {}) : (input || "");
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * UiRelayApi - functional programming interface
 * @export
 */
exports.UiRelayApiFp = function (configuration) {
    return {
        /**
         *
         * @param {CreateRelayUserInput} [input]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2RelayUsersPost: function (input, options) {
            var localVarAxiosArgs = exports.UiRelayApiAxiosParamCreator(configuration).apiV2RelayUsersPost(input, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = axios_1.default; }
                if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                var axiosRequestArgs = __assign({}, localVarAxiosArgs.options, { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
    };
};
/**
 * UiRelayApi - factory interface
 * @export
 */
exports.UiRelayApiFactory = function (configuration, basePath, axios) {
    return {
        /**
         *
         * @param {CreateRelayUserInput} [input]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2RelayUsersPost: function (input, options) {
            return exports.UiRelayApiFp(configuration).apiV2RelayUsersPost(input, options)(axios, basePath);
        },
    };
};
/**
 * UiRelayApi - object-oriented interface
 * @export
 * @class UiRelayApi
 * @extends {BaseAPI}
 */
var UiRelayApi = /** @class */ (function (_super) {
    __extends(UiRelayApi, _super);
    function UiRelayApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @param {CreateRelayUserInput} [input]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UiRelayApi
     */
    UiRelayApi.prototype.apiV2RelayUsersPost = function (input, options) {
        return exports.UiRelayApiFp(this.configuration).apiV2RelayUsersPost(input, options)(this.axios, this.basePath);
    };
    return UiRelayApi;
}(base_1.BaseAPI));
exports.UiRelayApi = UiRelayApi;
